import { pl as leafletCreation } from '@/modules/leaflet-creation/messages'

export default {
  leafletCreation,
  shared: {
    ok: 'OK',
    cancel: 'Anuluj',
    close: 'Zamknij',
    create: 'Utwórz',
    update: 'Aktualizuj',
    save: 'Zapisz',
    delete: 'Usuń',
    edit: 'Edytuj',
    warning: 'Ostrzeżenie',
    devices: {
      android: 'Android',
      androidMG: 'Moja Gazetka (Android)',
      androidMP: 'mPromocje (Android2)',
      iOS: 'iOS',
      ios: 'iOS',
      web: 'Web',
      wp: 'WP',
      all: 'Wszystkie platformy',
      android2: {
        'dev-1-pl': 'mPromocje',
        'dev-1-ua': 'Love Sales Light',
        'preprod-pl': 'mPromocje',
        'preprod-ua': 'Love Sales Light',
        'local': 'mPromocje',
        'pl': 'mPromocje',
        'ua': 'Love Sales Light'
      }
    },
    loading: 'Ładowanie...',
    retry: 'Ponów'
  },
  expand: 'Rozwiń',
  collapse: 'Zwiń',
  localeChanged: 'Poprawnie zmieniono język',
  common: {
    update: 'Aktualizuj',
    cancel: 'Anuluj',
    confirm: 'Potwierdź',
    create: 'Utwórz',
    delete: 'Usuń',
    apply: 'Zastosuj',
    copyToClipboard: 'Kopiuj do schowka',
    copiedToClipboard: 'Skopiowano do schowka',
    copyFailed: 'Nie udało się skopiować do schowka',
    clickToViewDetails: 'Kliknij, aby zobaczyć szczegóły'
  },
  locationGroups: {
    manage: 'Presety lokalizacji',
    title: 'Presety lokalizacji — {store}',
    create: 'Utwórz preset',
    empty: 'Brak presetów',
    fields: { name: 'Nazwa', available: 'Dostępne lokalizacje', unavailable: 'Wykluczone lokalizacje' },
    availableCount: 'Dostępne: {count}',
    unavailableCount: 'Wykluczone: {count}',
    editAria: 'Edytuj preset {name}',
    deleteAria: 'Usuń preset {name}',
    deleteConfirm: 'Usunąć preset „{name}”?',
    validation: {
      name: 'Podaj nazwę presetu',
      invalidLocations: 'Popraw nieprawidłowe lokalizacje',
      locationsRequired: 'Dodaj co najmniej jedną lokalizację'
    },
    notice: { saved: 'Zapisano', savedReloadFailed: 'Zapisano, nie udało się odświeżyć' },
    errors: {
      duplicateName: 'Preset o tej nazwie już istnieje',
      exists: 'Preset już istnieje',
      notFound: 'Nie znaleziono presetu',
      invalid: 'Nieprawidłowe dane presetu',
      unauthorized: 'Sesja wygasła',
      forbidden: 'Brak uprawnień',
      server: 'Błąd serwera',
      network: 'Błąd sieci',
      unexpectedStatus: 'Nieoczekiwana odpowiedź serwera',
      unknown: 'Nie udało się wykonać operacji',
      load: 'Nie udało się pobrać presetów'
    },
    selector: {
      placeholder: 'Wybierz preset',
      apply: 'Zastosuj',
      confirmReplace: 'Zastąpić obecne lokalizacje gazetki?'
    },
    saveAs: { label: 'Zapisz jako preset lokalizacji', action: 'Zapisz' }
  },
  notification: {
    success: 'Sukces',
    error: 'Błąd',
    warning: 'Ostrzeżenie',
    info: 'Info',
    priorityUnavailable: 'Istnieje już gazetka dla {os} z pozycją numer {priorityNumber} (id: {naturalId})',
    failedToProcessFile:
      'Nie udało się przetworzyć plików. Upewnij się, że pliki mają odpowiednie rozszerzenia(pojedynczy plik .pdf lub wiele plików .jpg/.png)',
    unknownError: 'Wystąpił nieznany błąd'
  },
  errorMessages: {
    unknownError: 'Nierozpoznany błąd.',
    leafletNotFound: 'Nie znaleziono gazetki o podanym ID.',
    invalidSession: 'Sesja wygasła. Zaloguj się ponownie.'
  },
  route: {
    dashboard: 'Sklepy i gazetki',
    xmlOffers: 'Kolejność gazetek',
    selectiveNotifications: 'Powiadomienia',
    categories: 'Kategorie',
    productHits: 'Hity produktowe',
    inserts: 'Inserty',
    users: 'Użytkownicy',
    groups: 'Grupy',
    archives: 'Archiwum',
    leafletsAlternative: 'Gazetek',
    leafletsArchive: 'Archiwum Gazetek',
    shopsArchive: 'Archiwum Sklepów',
    shopsAlternative: 'Sklepów',
    notificationsArchive: 'Archiwum Notyfikacji',
    notificationsAlternative: 'Notyfikacji',
    insertsAlternative: 'Insertów',
    insertsArchive: 'Archiwum Insertów',
    leafletDetails: 'Archiwum Szczegółów gazetek',
    leafletAlternative: 'Szczegółów gazetek',
    logs: 'Rejestr zdarzeń',
    leaflets: 'Gazetki',
    pageDetails: 'Szczegóły stron',
    password: 'Zmień hasło',
    cooksAndRecipes: 'Kucharze i przepisy',
    scrapper: 'Scrapper',
    scrapperNewLeafletsSearch: 'Wyszukiwanie nowych gazetek',
    scrapperNewLeafletsSearchAlternative: 'Wyszukiwanie nowych gazetek',
    reels: 'Kanały',
    appConfig: 'Konfiguracja Aplikacji',
    loyaltyCards: 'Karty Lojalnościowe',
    slider: 'Slider',
    tradeDays: 'Dni Handlowe',
    productCategories: 'Kategorie produktów'
  },
  appConfig: {
    title: 'Konfiguracja zdalna',
    subtitle: 'Zarządzaj konfiguracjami zdalnymi dla aplikacji mobilnych i webowych',
    platforms: {
      all: 'Wszystkie platformy',
      ios: 'iOS',
      android: 'Android',
      web: 'Web'
    },
    webPopularCities: {
      sectionTitle: 'Popularne miasta w aplikacji webowej',
      subtitle: 'Skonfiguruj popularne miasta wyświetlane w aplikacji webowej',
      citiesConfig: 'Konfiguracja miast',
      dragHint: 'Przeciągnij, aby zmienić kolejność miast',
      city: 'Miasto',
      addCity: 'Dodaj miasto',
      saveChanges: 'Zapisz zmiany',
      resetChanges: 'Anuluj zmiany',
      saveSuccess: 'Konfiguracja miast została zapisana pomyślnie',
      saveError: 'Błąd podczas zapisywania konfiguracji miast',
      loadingError: 'Błąd ładowania danych',
      loadingErrorDesc: 'Nie udało się pobrać konfiguracji popularnych miast',
      tryAgain: 'Spróbuj ponownie',
      validationErrors: 'Błędy walidacji',
      validation: {
        cityRequired: 'Nazwa miasta jest wymagana',
        cityMinLength: 'Nazwa miasta musi mieć co najmniej 1 znak'
      }
    },
    webLeafletView: {
      sectionTitle: 'Widok gazetki w aplikacji webowej',
      subtitle: 'Skonfiguruj ustawienia widoku gazetki w aplikacji webowej',
      adsOnPageConfig: 'Konfiguracja reklam na stronę',
      adsOnPage: 'Reklamy na stronę',
      addAdsOnPage: 'Dodaj opcję reklam na stronę',
      saveChanges: 'Zapisz zmiany',
      resetChanges: 'Anuluj zmiany',
      saveSuccess: 'Konfiguracja widoku gazetki została zapisana pomyślnie',
      saveError: 'Błąd podczas zapisywania konfiguracji widoku gazetki',
      loadingError: 'Błąd ładowania danych',
      loadingErrorDesc: 'Nie udało się pobrać konfiguracji widoku gazetki',
      tryAgain: 'Spróbuj ponownie',
      validationErrors: 'Błędy walidacji',
      validation: {
        adsOnPageRequired: 'Wartość reklam na stronę jest wymagana',
        adsOnPagePositive: 'Wartość reklam na stronę musi być liczbą dodatnią',
        adsOnPageMinLength: 'Wymagana jest co najmniej jedna opcja reklam na stronę'
      }
    },
    webPopularStores: {
      sectionTitle: 'Popularne sklepy w aplikacji webowej',
      subtitle: 'Skonfiguruj popularne sklepy wyświetlane w aplikacji webowej',
      storesConfig: 'Konfiguracja sklepów',
      selectStores: 'Wybierz sklepy',
      selectStoresPlaceholder: 'Wybierz sklepy do wyświetlenia',
      selectedStores: 'Wybrane sklepy',
      saveChanges: 'Zapisz zmiany',
      resetChanges: 'Anuluj zmiany',
      saveSuccess: 'Konfiguracja sklepów została zapisana pomyślnie',
      saveError: 'Błąd podczas zapisywania konfiguracji sklepów',
      loadingError: 'Błąd ładowania danych',
      loadingErrorDesc: 'Nie udało się pobrać konfiguracji popularnych sklepów',
      storesLoadingError: 'Błąd ładowania sklepów',
      storesLoadingErrorDesc: 'Nie udało się pobrać listy sklepów',
      tryAgain: 'Spróbuj ponownie',
      validationErrors: 'Błędy walidacji',
      validation: {
        storeIdRequired: 'ID sklepu jest wymagane',
        storeIdMinLength: 'ID sklepu musi mieć co najmniej 1 znak',
        storesMinLength: 'Wymagany jest co najmniej jeden sklep'
      }
    },
    webMegaMenu: {
      sectionTitle: 'Mega Menu w aplikacji webowej',
      subtitle: 'Skonfiguruj mega menu dla aplikacji webowej',
      storeCategories: 'Kategorie sklepów',
      categoryName: 'Nazwa kategorii',
      selectStores: 'Wybierz sklepy',
      selectStoresPlaceholder: 'Wybierz sklepy dla tej kategorii',
      selectedStores: 'Wybrane sklepy',
      addCategory: 'Dodaj kategorię',
      recipesConfig: 'Konfiguracja przepisów',
      selectCooks: 'Wybierz kucharzy',
      selectCooksPlaceholder: 'Wybierz kucharzy do wyświetlenia',
      selectedCooks: 'Wybrani kucharze',
      saveChanges: 'Zapisz zmiany',
      resetChanges: 'Anuluj zmiany',
      saveSuccess: 'Konfiguracja mega menu została zapisana pomyślnie',
      saveError: 'Błąd podczas zapisywania konfiguracji mega menu',
      loadingError: 'Błąd ładowania danych',
      loadingErrorDesc: 'Nie udało się pobrać konfiguracji mega menu',
      storesLoadingError: 'Błąd ładowania sklepów',
      storesLoadingErrorDesc: 'Nie udało się pobrać listy sklepów',
      cooksLoadingError: 'Błąd ładowania kucharzy',
      cooksLoadingErrorDesc: 'Nie udało się pobrać listy kucharzy',
      tryAgain: 'Spróbuj ponownie',
      validationErrors: 'Błędy walidacji',
      validation: {
        categoryNameRequired: 'Nazwa kategorii jest wymagana',
        categoryNameMinLength: 'Nazwa kategorii musi mieć co najmniej 1 znak',
        storeIdRequired: 'ID sklepu jest wymagane',
        storeIdMinLength: 'ID sklepu musi mieć co najmniej 1 znak',
        storesMinLength: 'Wymagany jest co najmniej jeden sklep',
        cookIdRequired: 'ID kucharza jest wymagane',
        cookIdMinLength: 'ID kucharza musi mieć co najmniej 1 znak'
      }
    },
    webFooterLinks: {
      sectionTitle: 'Linki stopki w aplikacji webowej',
      subtitle: 'Skonfiguruj linki stopki dla aplikacji webowej',
      storesPopular: 'Popularne sklepy',
      locationsPopular: 'Popularne lokalizacje',
      articlesPopular: 'Popularne artykuły',
      dragHint: 'Przeciągnij, aby zmienić kolejność linków',
      linkName: 'Nazwa linku',
      linkUrl: 'URL linku',
      addLink: 'Dodaj link',
      saveChanges: 'Zapisz zmiany',
      resetChanges: 'Anuluj zmiany',
      saveSuccess: 'Konfiguracja linków stopki została zapisana pomyślnie',
      saveError: 'Błąd podczas zapisywania konfiguracji linków stopki',
      loadingError: 'Błąd ładowania danych',
      loadingErrorDesc: 'Nie udało się pobrać konfiguracji linków stopki',
      tryAgain: 'Spróbuj ponownie',
      validationErrors: 'Błędy walidacji',
      validation: {
        nameRequired: 'Nazwa linku jest wymagana',
        nameMinLength: 'Nazwa linku musi mieć co najmniej 1 znak',
        urlRequired: 'URL linku jest wymagany',
        urlMinLength: 'URL linku musi mieć co najmniej 1 znak'
      }
    },
    webRecipes: {
      sectionTitle: 'Przepisy w aplikacji webowej',
      subtitle: 'Skonfiguruj przepisy dla aplikacji webowej',
      promotedRecipes: 'Promowane przepisy',
      selectRecipes: 'Wybierz przepisy',
      selectRecipesPlaceholder: 'Wybierz przepisy do promowania',
      selectedRecipes: 'Wybrane przepisy',
      saveChanges: 'Zapisz zmiany',
      resetChanges: 'Anuluj zmiany',
      saveSuccess: 'Konfiguracja przepisów została zapisana pomyślnie',
      saveError: 'Błąd podczas zapisywania konfiguracji przepisów',
      loadingError: 'Błąd ładowania danych',
      loadingErrorDesc: 'Nie udało się pobrać konfiguracji przepisów',
      recipesLoadingError: 'Błąd ładowania przepisów',
      recipesLoadingErrorDesc: 'Nie udało się pobrać listy przepisów',
      tryAgain: 'Spróbuj ponownie',
      validationErrors: 'Błędy walidacji',
      validation: {
        recipeIdRequired: 'ID przepisu jest wymagane',
        recipeIdMinLength: 'ID przepisu musi mieć co najmniej 1 znak'
      }
    },
    accordions: {
      articles: 'Artykuły - Konfiguracja listy',
      articlesSection: 'Artykuły - Ustawienia sekcji',
      mobileWhatsNewBanner: 'Baner "Co nowego" w aplikacji mobilnej',
      searchSettings: 'Ustawienia wyszukiwania',
      keywords: 'Zarządzanie słowami kluczowymi',
      mobileRecommendationType: 'Rekomendacje - Typ',
      mobileRecommendationHighlightedLeafletId: 'Rekomendacje - ID wyróżnionej gazetki',
      mobileRecommendationCustomTypeLink: 'Rekomendacje - Link niestandardowego typu',
      mobileOnboarding: 'Sklepy w onboardingu mobilnym',
      mobileRecommendationCustomTypePictureUrl: 'Rekomendacje - URL obrazka niestandardowego typu',
      webPopularCities: 'Web - Popularne miasta',
      webLeafletView: 'Web - Widok gazetki',
      webPopularStores: 'Web - Popularne sklepy',
      webMegaMenu: 'Web - Mega Menu',
      webFooterLinks: 'Web - Linki stopki',
      webRecipes: 'Web - Przepisy',
      aiConfiguration: 'Konfiguracja AI',
      roboflow: 'Synchronizacja Roboflow'
    },
    articlesSectionSettings: {
      title: 'Ustawienia sekcji artykułów',
      subtitle: 'Skonfiguruj ustawienia sekcji artykułów w aplikacji',
      noConfig: 'Brak konfiguracji do wyświetlenia',
      noValue: 'Brak wartości',
      addSection: 'Dodaj sekcję',
      iconUrl: 'URL ikony',
      useBigSize: 'Użyj dużego rozmiaru',
      position: 'Pozycja',
      saveChanges: 'Zapisz zmiany i opublikuj',
      saveError: 'Błąd podczas zapisywania',
      saveSuccess: 'Konfiguracja została zapisana pomyślnie',
      loadingError: 'Błąd ładowania danych',
      loadingErrorDesc: 'Nie udało się pobrać ustawień sekcji',
      tryAgain: 'Spróbuj ponownie',
      validation: {
        titleRequired: 'Tytuł jest wymagany',
        titleMinLength: 'Tytuł musi mieć co najmniej 3 znaki',
        iconUrlRequired: 'URL ikony jest wymagany',
        iconUrlInvalid: 'URL ikony musi być prawidłowym adresem URL',
        positionRequired: 'Pozycja jest wymagana',
        positionInvalid: 'Pozycja musi być prawidłową liczbą całkowitą'
      }
    },
    mobileWhatsNewBanner: {
      sectionTitle: 'Baner "Co nowego" w aplikacji mobilnej',
      subtitle: 'Skonfiguruj baner "Co nowego" wyświetlany w aplikacjach mobilnych',
      noConfig: 'Brak konfiguracji do wyświetlenia',
      noValue: 'Brak wartości',
      addBanner: 'Dodaj baner',
      clearBanner: 'Wyczyść baner',
      bannerConfig: 'Konfiguracja banera',
      id: 'ID',
      title: 'Tytuł',
      message: 'Wiadomość',
      deeplink: 'Deeplink',
      badge: 'Odznaka',
      saveChanges: 'Zapisz zmiany i opublikuj',
      resetChanges: 'Resetuj zmiany',
      saveError: 'Błąd podczas zapisywania',
      validationErrors: 'Błędy walidacji',
      saveSuccess: 'Konfiguracja została zapisana pomyślnie',
      loadingError: 'Błąd ładowania danych',
      loadingErrorDesc: 'Nie udało się pobrać ustawień banera',
      tryAgain: 'Spróbuj ponownie',
      validation: {
        idMinLength: 'ID musi mieć co najmniej 3 znaki',
        titleMinLength: 'Tytuł musi mieć co najmniej 3 znaki',
        messageMinLength: 'Wiadomość musi mieć co najmniej 3 znaki',
        deeplinkMinLength: 'Deeplink musi mieć co najmniej 3 znaki',
        badgeMinLength: 'Odznaka musi mieć co najmniej 3 znaki'
      }
    },
    searchSettings: {
      sectionTitle: 'Ustawienia wyszukiwania',
      subtitle: 'Skonfiguruj ustawienia wyszukiwania dla aplikacji mobilnych',
      noConfig: 'Brak konfiguracji do wyświetlenia',
      noValue: 'Brak wartości',
      addSettings: 'Dodaj ustawienia',
      clearSettings: 'Wyczyść ustawienia',
      settingsConfig: 'Konfiguracja ustawień wyszukiwania',
      includeAdBanner: 'Dołącz baner reklamowy',
      searchTip: 'Podpowiedź wyszukiwania',
      popularWords: 'Popularne słowa',
      addWord: 'Dodaj słowo',
      includePopularStores: 'Dołącz popularne sklepy',
      popularStores: 'Popularne sklepy',
      addStore: 'Dodaj sklep',
      includePopularLeaflets: 'Dołącz popularne gazetki',
      popularLeaflets: 'Popularne gazetki',
      addLeaflet: 'Dodaj gazetkę',
      saveChanges: 'Zapisz zmiany i opublikuj',
      resetChanges: 'Resetuj zmiany',
      saveError: 'Błąd podczas zapisywania',
      validationErrors: 'Błędy walidacji',
      validation: {
        searchTipRequired: 'Podpowiedź wyszukiwania nie może być pusta'
      },
      saveSuccess: 'Konfiguracja została zapisana pomyślnie',
      loadingError: 'Błąd ładowania danych',
      loadingErrorDesc: 'Nie udało się pobrać ustawień wyszukiwania',
      tryAgain: 'Spróbuj ponownie'
    },
    keywords: {
      sectionTitle: 'Zarządzanie słowami kluczowymi',
      subtitle: 'Zarządzaj słowami kluczowymi używanymi w aplikacji',
      add: 'Dodaj',
      addQueryAction: 'Dodaj "{query}"',
      existingKeywords: 'Istniejące słowa kluczowe',
      totalCount: 'Łącznie: {count} słów kluczowych',
      filteredCount: 'Wyświetlane: {count}',
      managementPlaceholder: 'Szukaj słów kluczowych lub dodaj nowe...',
      noKeywordsYet: 'Brak słów kluczowych',
      noKeywordsYetAddable: 'Brak słów kluczowych. "{query}" może zostać dodane jako pierwsze słowo kluczowe.',
      noFilteredKeywords: 'Brak słów kluczowych pasujących do wyszukiwania',
      removeKeywords: 'Usuń słowa kluczowe',
      removePlaceholder: 'Wybierz słowa kluczowe do usunięcia...',
      removeHint:
        'Wybierz jedno lub więcej słów kluczowych z listy, aby je usunąć, lub kliknij × na dowolnym tagu powyżej.',
      remove: 'Usuń',
      cancel: 'Anuluj',
      removeConfirm: 'Czy na pewno chcesz usunąć {count} słów kluczowych?',
      removeConfirmSingle: 'Czy na pewno chcesz usunąć to słowo kluczowe?',
      removeConfirmMultiple: 'Czy na pewno chcesz usunąć {count} słów kluczowych?',
      removeTitle: 'Usuń słowa kluczowe',
      updateSuccess: 'Słowa kluczowe zostały zaktualizowane pomyślnie',
      updateError: 'Błąd podczas aktualizacji słów kluczowych',
      error: 'Błąd',
      validationErrors: 'Błędy walidacji'
    },
    mobileRecommendationType: {
      sectionTitle: 'Typ rekomendacji mobilnej',
      subtitle: 'Skonfiguruj typy rekomendacji dla aplikacji mobilnych',
      noConfig: 'Brak konfiguracji do wyświetlenia',
      noValue: 'Brak wartości',
      addRecommendationType: 'Dodaj typ rekomendacji',
      clearRecommendationType: 'Wyczyść typ rekomendacji',
      recommendationConfig: 'Konfiguracja typu rekomendacji',
      value: 'Typ rekomendacji',
      saveChanges: 'Zapisz zmiany',
      resetChanges: 'Resetuj zmiany',
      saveError: 'Błąd podczas zapisywania',
      validationErrors: 'Błędy walidacji',
      validation: {
        valueRequired: 'Proszę wybrać typ rekomendacji',
        invalidValue: 'Proszę wybrać prawidłowy typ rekomendacji',
        pictureUrlRequired:
          'Musisz ustawić adres URL obrazka przed użyciem typu Obraz z linkiem. Przejdź do sekcji URL obrazka niestandardowego typu i ustaw prawidłowy adres URL.',
        linkRequired:
          'Musisz ustawić link przed użyciem typu Obraz z linkiem. Przejdź do sekcji Link niestandardowego typu i ustaw prawidłowy link.'
      },
      options: {
        singleLeaflet: 'Pojedyncza gazetka',
        fourLeaflets: 'Cztery gazetki',
        leafletsAndStores: 'Gazetki i sklepy',
        leafletsStoreRating: 'Gazetki z oceną sklepu',
        twoLeafletsThreeStoresRating: 'Dwie gazetki i trzy sklepy z oceną',
        twoLeafletsFavouriteRating: 'Dwie gazetki z ulubionymi i oceną',
        twoLeafletsFavouriteThreeStores: 'Dwie gazetki z ulubionymi i trzy sklepy',
        imageWithLink: 'Obraz z linkiem'
      },
      untitled: 'Bez tytułu',
      saveSuccess: 'Konfiguracja zapisana pomyślnie',
      loadingError: 'Błąd ładowania danych',
      loadingErrorDesc: 'Nie udało się pobrać ustawień typu rekomendacji',
      tryAgain: 'Spróbuj ponownie'
    },
    mobileRecommendationHighlightedLeafletId: {
      sectionTitle: 'ID wyróżnionej gazetki',
      subtitle: 'Skonfiguruj ID wyróżnionej gazetki dla aplikacji mobilnych',
      noConfig: 'Brak konfiguracji do wyświetlenia',
      highlightedLeafletConfig: 'Konfiguracja ID wyróżnionej gazetki',
      value: 'ID gazetki',
      saveChanges: 'Zapisz zmiany',
      resetChanges: 'Resetuj zmiany',
      saveError: 'Błąd podczas zapisywania',
      validationErrors: 'Błędy walidacji',
      saveSuccess: 'Konfiguracja zapisana pomyślnie',
      loadingError: 'Błąd ładowania danych',
      loadingErrorDesc: 'Nie udało się pobrać ustawień ID wyróżnionej gazetki',
      tryAgain: 'Spróbuj ponownie'
    },
    mobileRecommendationCustomTypeLink: {
      sectionTitle: 'Link niestandardowego typu',
      subtitle: 'Skonfiguruj link niestandardowego typu dla aplikacji mobilnych',
      disclaimer: 'Ważne:',
      disclaimerText:
        'Ta konfiguracja ma zastosowanie tylko wtedy, gdy typ rekomendacji jest ustawiony na "Obraz z linkiem" (typ 7).',
      noConfig: 'Brak konfiguracji do wyświetlenia',
      customTypeLinkConfig: 'Konfiguracja linku niestandardowego typu',
      value: 'Wartość linku',
      saveChanges: 'Zapisz zmiany',
      resetChanges: 'Resetuj zmiany',
      saveError: 'Błąd podczas zapisywania',
      validationErrors: 'Błędy walidacji',
      saveSuccess: 'Konfiguracja zapisana pomyślnie',
      loadingError: 'Błąd ładowania danych',
      loadingErrorDesc: 'Nie udało się pobrać ustawień linku niestandardowego typu',
      tryAgain: 'Spróbuj ponownie'
    },
    mobileRecommendationCustomTypePictureUrl: {
      sectionTitle: 'URL obrazka niestandardowego typu',
      subtitle: 'Skonfiguruj URL obrazka niestandardowego typu dla aplikacji mobilnych',
      disclaimer: 'Ważne:',
      disclaimerText:
        'Ta konfiguracja ma zastosowanie tylko wtedy, gdy typ rekomendacji jest ustawiony na "Obraz z linkiem" (typ 7).',
      noConfig: 'Brak konfiguracji do wyświetlenia',
      customTypePictureUrlConfig: 'Konfiguracja URL obrazka niestandardowego typu',
      value: 'URL obrazka',
      preview: 'Podgląd',
      imageLoadError: 'Nie udało się załadować obrazka. Sprawdź URL.',
      saveChanges: 'Zapisz zmiany',
      resetChanges: 'Resetuj zmiany',
      saveError: 'Błąd podczas zapisywania',
      validationErrors: 'Błędy walidacji',
      saveSuccess: 'Konfiguracja zapisana pomyślnie',
      validation: {
        urlInvalid: 'URL musi być prawidłowy'
      },
      loadingError: 'Błąd ładowania danych',
      loadingErrorDesc: 'Nie udało się pobrać ustawień URL obrazka niestandardowego typu',
      tryAgain: 'Spróbuj ponownie',
      uploadImage: 'Prześlij obraz',
      imageUploadSuccess: 'Obraz został przesłany pomyślnie',
      imageUploadError: 'Błąd podczas przesyłania obrazu'
    },
    mobileOnboarding: {
      title: 'Sklepy w onboardingu mobilnym',
      description: 'Skonfiguruj listę sklepów pokazywanych podczas onboardingu aplikacji mobilnej',
      loadingError: 'Błąd ładowania konfiguracji',
      loadingErrorDesc: 'Wystąpił błąd podczas ładowania konfiguracji. Spróbuj ponownie.',
      tryAgain: 'Spróbuj ponownie',
      saveSuccess: 'Konfiguracja zapisana pomyślnie',
      saveError: 'Błąd podczas zapisywania konfiguracji',
      validation: {
        storeIdRequired: 'ID sklepu jest wymagane'
      },
      storesLabel: 'Sklepy do onboardingu',
      storesPlaceholder: 'Wybierz lub wprowadź ID sklepów',
      storesHelpText: 'Te sklepy będą pokazywane użytkownikom podczas procesu onboardingu w aplikacji mobilnej',
      saveButton: 'Zapisz'
    },
    form: {
      platformLabel: 'Wybierz platformę'
    },
    articlesList: {
      title: 'Konfiguracja listy artykułów',
      subtitle: 'Tutaj możesz skonfigurować ustawienia wyświetlania artykułów w aplikacji',
      noConfig: 'Brak konfiguracji do wyświetlenia',
      noValue: 'Brak wartości',
      addArticles: 'Dodaj artykuły',
      article: 'Artykuł',
      dragHint: 'Przeciągnij, aby zmienić kolejność artykułów',
      additionalInfo: 'Dodatkowe informacje',
      imageUrl: 'URL obrazka',
      articleUrl: 'URL artykułu',
      isSponsored: 'Sponsorowany',
      addArticle: 'Dodaj artykuł',
      addArticleAtBeginning: 'Dodaj artykuł na początku',
      addArticleAtEnd: 'Dodaj artykuł na końcu',
      saveChanges: 'Zapisz zmiany i opublikuj',
      resetChanges: 'Resetuj zmiany',
      saveError: 'Błąd podczas zapisywania',
      saveSuccess: 'Konfiguracja została zapisana pomyślnie',
      copySuccess: 'Konfiguracja została skopiowana pomyślnie',
      copyError: 'Błąd podczas kopiowania konfiguracji',
      configDifference: 'Wykryto różnice w konfiguracji',
      validation: {
        titleRequired: 'Tytuł jest wymagany',
        titleMinLength: 'Tytuł musi mieć co najmniej 3 znaki',
        additionalInfoRequired: 'Dodatkowe informacje są wymagane',
        imageUrlRequired: 'URL obrazka jest wymagany',
        imageUrlInvalid: 'URL obrazka musi być prawidłowym adresem URL',
        articleUrlRequired: 'URL artykułu jest wymagany',
        articleUrlInvalid: 'URL artykułu musi być prawidłowym adresem URL'
      },
      configDifferenceDescription:
        'Konfiguracje Android i iOS różnią się. Możesz skopiować konfigurację Android do iOS.',
      copyToIos: 'Kopiuj do iOS',
      allArticlesRemoved: 'Wszystkie artykuły zostały usunięte',
      articlesCount: '{count} artykuł(ów)',
      loadingError: 'Błąd ładowania danych',
      loadingErrorDesc: 'Nie udało się pobrać listy artykułów',
      tryAgain: 'Spróbuj ponownie',
      uploadImage: 'Prześlij obraz',
      imageUploadSuccess: 'Obraz został przesłany pomyślnie',
      imageUploadError: 'Błąd podczas przesyłania obrazu',
      basic: 'PODSTAWOWY'
    },
    loyaltyCards: 'Karty lojalnościowe',
    aiConfiguration: {
      sectionTitle: 'Konfiguracja AI',
      subtitle: 'Skonfiguruj ustawienia AI dla rozpoznawania ofert',
      noConfig: 'Brak konfiguracji AI dla tego kraju',
      createConfig: 'Utwórz konfigurację',
      provider: 'Provider AI',
      selectProvider: 'Wybierz providera AI',
      model: 'Model AI',
      selectModel: 'Wybierz model AI',
      prompt: 'Prompt',
      promptPlaceholder: 'Wprowadź prompt AI dla rozpoznawania ofert...',
      promptHint:
        'Ten prompt zostanie wysłany do modelu AI, aby kierować rozpoznawaniem ofert. Określ dokładnie oczekiwany format wyjściowy.',
      pagePrompt: 'Prompt strony (opcjonalny)',
      pagePromptPlaceholder: 'Wprowadź prompt do odczytu dat obowiązywania ofert ze strony gazetki...',
      pagePromptHint: 'Instrukcja odczytu dat z całej strony gazetki. Puste pole zapisuje pusty prompt.',
      currency: 'Waluta rozpoznawanych ofert (opcjonalna)',
      currencyPlaceholder: 'Kod waluty, np. PLN',
      currencyHint:
        'Wprowadź trzy litery kodu waluty. Kod zostanie zapisany wielkimi literami. Przy edycji puste pole pozostawia dotychczasową walutę.',
      units: 'Jednostki miary',
      addUnit: 'Dodaj jednostkę',
      unitsHint: 'Jednostki używane do pomiaru produktów (np. kg, g, l, ml, szt)',
      suggestedUnits: 'Sugerowane',
      metadata: 'Metadane konfiguracji',
      country: 'Kraj',
      createdDate: 'Utworzono',
      lastModified: 'Ostatnia modyfikacja',
      create: 'Utwórz konfigurację',
      saveChanges: 'Zapisz zmiany',
      resetChanges: 'Resetuj',
      saveSuccess: 'Konfiguracja AI została zapisana pomyślnie',
      saveError: 'Błąd podczas zapisywania konfiguracji AI',
      saveFailed: 'Nie udało się zapisać konfiguracji. Spróbuj ponownie.',
      invalidData: 'Nieprawidłowe dane konfiguracji',
      noPermission: 'Nie masz uprawnień do modyfikacji tej konfiguracji',
      validationError: 'Napraw błędy walidacji',
      validationErrors: 'Błędy walidacji',
      loadingError: 'Błąd podczas ładowania konfiguracji AI',
      loadingErrorDesc: 'Nie udało się pobrać konfiguracji AI',
      tryAgain: 'Spróbuj ponownie',
      validation: {
        providerRequired: 'Provider jest wymagany',
        providerInvalid: 'Provider musi mieć wartość OPENAI, GOOGLE lub DEEPSEEK',
        currencyInvalid: 'Kod waluty musi składać się z trzech liter',
        modelRequired: 'Model jest wymagany',
        modelInvalid: 'Model może zawierać tylko litery, cyfry, myślniki i kropki',
        promptMinLength: 'Prompt musi mieć co najmniej 10 znaków',
        unitInvalid: 'Jednostki mogą zawierać tylko znaki alfanumeryczne'
      }
    },
    roboflow: {
      sectionTitle: 'Synchronizacja Roboflow',
      subtitle: 'Wyślij zakolejkowane strony gazetek do zbioru treningowego Roboflow.',
      maxImagesNumber: 'Maksymalna liczba obrazów',
      maxImagesNumberHint: 'Określa maksymalną liczbę zakolejkowanych obrazów wysyłanych w tej operacji.',
      store: 'Sklep (opcjonalnie)',
      allStores: 'Wszystkie sklepy',
      storeHint: 'Pozostaw puste, aby synchronizować obrazy bez filtrowania po sklepie.',
      storesLoadingError: 'Nie udało się pobrać listy sklepów. Nadal możesz synchronizować wszystkie sklepy.',
      synchronize: 'Uruchom synchronizację',
      confirmTitle: 'Uruchomić synchronizację Roboflow?',
      confirmMessage: 'Do wysłania zostanie zakwalifikowanych maksymalnie {count} obrazów. Sklep: {store}.',
      synchronizeSuccess: 'Synchronizacja zakolejkowanych obrazów została uruchomiona.',
      synchronizeError: 'Nie udało się uruchomić synchronizacji Roboflow.',
      validation: {
        maxImagesNumber: 'Liczba obrazów musi być dodatnią liczbą całkowitą.'
      }
    }
  },
  dashboard: {
    title: 'Sklepy i gazetki',
    preventCloseTab: 'Na pewno chcesz opuścić stronę? Stracisz niezapisane zmiany!',
    nothing: 'Brak',
    missingLeafletForStore: 'Brakuje gazetek',
    actions: 'Akcje',
    publicationPlanned: 'Publikacja zaplanowana',
    leafletProcessing: {
      pending: 'Oczekuje na przetwarzanie',
      processing: 'Przetwarzanie gazetki...',
      failed: 'Błąd przetwarzania',
      failedHint: 'Nie udało się wygenerować obrazów gazetki. Otwórz gazetkę i spróbuj ponownie.'
    },
    search: {
      placeholder: 'Szukaj sklepu, ID gazetki lub nazwy gazetki'
    },
    storesWithoutLeaflets: {
      title: 'Sklepy bez gazetek'
    },
    productsToCheck: {
      title: 'Produkty do sprawdzenia'
    },
    xml: {
      button: 'Opublikuj zmiany',
      confirm: 'Czy na pewno chcesz opublikować gazetki?',
      success: 'Gazetki opublikowane pomyślnie',
      successWithNotifications: 'Gazetki opublikowane pomyślnie.\nPowiadomienia wygenerowane pomyślnie dla: ',
      allPlatforms: 'Wszystkie platformy',
      inProgress: 'Gazetki są w trakcie publikacji. Powiadomimy Cię, gdy proces publikacji się zakończy.',
      inProgressWithNotification:
        'Gazetki są w trakcie publikacji. Powiadomimy Cie, gdy proces publikacji się zakończy i powiadomienia zostaną rozesłane.',
      generateNotificationsInProgress:
        'Notyfikacje są w trakcie generowania. Powiadomimy Cię, gdy proces generowania się zakończy.',
      lastGenerated: 'Ostatnia publikacja zmian',
      generatedBy: 'przez'
    },
    xmlAndNotifications: {
      button: 'Opublikuj gazetki i wygeneruj powiadomienia',
      confirm: 'Czy na pewno chcesz opublikować gazetki i wygenerować powiadomienia?'
    },
    activation: {
      success: 'Gazetka gotowa na aktywację.'
    },
    cutRequest: {
      request: 'Potnij',
      retry: 'Ponów',
      cutAgain: 'Potnij ponownie',
      rerun: 'Ponów cięcie',
      rerunConfirmTitle: 'Ponowić cięcie?',
      rerunConfirmMessage:
        'Ponowne cięcie przeprocesuje całą gazetkę i może zastąpić obecne oferty oraz ręczne poprawki.',
      rerunConfirmConfirm: 'Ponów cięcie',
      success: 'Żądanie pocięcia wysłane pomyślnie',
      error: 'Błąd podczas wysyłania żądania pocięcia',
      featureDisabled: 'Funkcja rozpoznawania ofert jest wyłączona'
    },
    cutStatus: {
      checking: 'Sprawdzanie statusu...',
      processing: 'Przetwarzanie',
      pending: '{count} stron w trakcie',
      complete: 'Pocięta',
      toFix: 'Do poprawy ({count})',
      failed: 'Cięcie nieudane ({count} stron) - Ponów',
      error: 'Nie udało się sprawdzić statusu - Ponów'
    },
    leafletStatus: {
      successPages: 'Pocięte:',
      errorPages: 'Niepocięte:',
      pendingPages: 'W trakcie:',
      pageTooltip: 'Strona {pageNumber}: {status}',
      statusText: {
        SUCCESS: 'Pocięta poprawnie',
        FAILED: 'Błąd',
        IN_PROGRESS: 'W trakcie'
      }
    },
    notifications: {
      button: 'Generuj powiadomienia',
      buttonSelect: 'Selektywne powiadomienia',
      confirm: 'Czy na pewno chcesz wygenerować powiadomienia?',
      success: 'Powiadomienia wygenerowane pomyślnie dla:',
      successNoStores: 'Nie wysłano nowych powiadomień. Brak nowych gazetek.',
      selectedShopsTitle: 'Generuj powiadomienia dla wybranych sklepów',
      selectedShopsTitleEdit: 'Edytuj powiadomienie',
      selectAll: 'Zaznacz wszystkie sklepy',
      selectAllGroups: 'Zaznacz wszystkie grupy',
      selectShops: 'Wybierz sklepy',
      selectGroups: 'Wybierz grupy',
      form: {
        id: 'Identyfikator:',
        titleLabel: 'Tytuł:',
        titlePlaceholder: 'Wprowadź tytuł',
        textLabel: 'Wiadomość:',
        channel: 'Kanał',
        bigIcon: 'Big icon URL',
        bigPicture: 'Big picture URL',
        uploadImage: 'Wybierz zdjęcie',
        deepLink: 'Deep link',
        webpageLink: 'Webpage link',
        showTrackingLink: 'Show tracking link',
        openTrackingLink: 'Open tracking link',
        geoLocations: 'Geolokalizacje',
        selectedShops: 'Sklepy',
        selectedGroups: 'Grupy',
        devices: 'Wysyłka dla',
        specialOffer: {
          description: 'Oferta specjalna',
          details: 'Pomija ustawienia sklepów ulubionych'
        },
        errors: {
          titleRequiredForChannels: 'Tytuł jest wymagany jeśli kanał jest inny niz NEW_OFFERS_NOTIFICATION',
          invalidGeolocationsFormat: 'Niepoprawny format geolokazji. Powinny być 3 elementy odseparowane przecinkiem',
          invalidLatitudeValue: 'Wartość latitude powinna być pomiędzy -90.0000000 a 90.0000000',
          invalidLongitudeValue: 'Wartość longitude powinna być pomiędzy -180.0000000 a 180.0000000',
          invalidRadiusValue: 'Wartość radius powinna być dodatnia',
          invalidUrlValue: 'Niepoprawny URL',
          newOffersNotificationSet: 'Wartość musi być pusta jeśli kanał ustawiony jest na NEW_OFFERS_NOTIFICATION',
          shopsRequired: 'Przynajmniej jeden sklep jest wymagany',
          devicesRequired: 'Przynajmniej jedna platforma jest wymagana'
        }
      }
    },
    planNotifications: {
      title: 'Ustaw wysyłanie',
      dateLabel: 'na dzień',
      hourLabel: 'na godzinę',
      saveLabel: 'Zaplanuj',
      successMessage: 'Zaplanowano wysyłanie powiadomień'
    },
    articlesData: {
      unmatchedData: 'Niedopasowane gazetki',
      noUnmatchedData: 'Brak niedopasowanych gazetek.',
      restoreArticles: 'Przywróć usunięte gazetki',
      restoreArticlesSuccess: 'Pomyślnie przyrwócono gazetkę',
      restoreArticlesInfo:
        'Przywraca usuniętym gazetkom status IMPORTED. Tylko aktualne gazetki mogą zostać przywrócone.',
      removeConfirm: 'Czy na pewno chcesz usunąć tą gazetkę?',
      status: 'status: ',
      importInProgress: 'W trakcie importu',
      close: 'Zamknij'
    },
    leaflets: {
      fetching: 'Ładowanie gazetek...',
      sorting: 'Sortowanie gazetek...',
      shopsUpdate: 'Dane sklepów są aktualizowane w tle. Zawartość strony może różnić się od danych na serwerze.',
      leafletsUpdate: 'Dane gazetek są aktualizowane w tle. Zawartość strony może różnić się od danych na serwerze.',
      fetch: {
        error: {
          title: 'Błąd podczas ładowania gazetek',
          description: 'Nie udało się pobrać danych gazetek. Spróbuj ponownie.'
        },
        partialError: {
          title: 'Niektóre gazetki nie mogły zostać załadowane',
          description: 'Niektóre gazetki nie zostały załadowane, ale pozostałe są wyświetlone poniżej.'
        }
      },
      empty: {
        description: 'Brak gazetek do wyświetlenia'
      },
      pageCount: 'Strony'
    },
    stores: {
      publishDate: 'Data publikacji',
      publishEndDate: 'Publikuj do',
      naturalId: 'Natural ID',
      seoId: 'Seo ID',
      identifiers: 'Natural ID / SEO ID',
      rejectModal: 'Czy na pewno odrzucić tę gazetkę?',
      additionalInfo: 'Tytuł',
      valid: 'Data',
      platforms: 'Platformy',
      validFromPrefix: 'od',
      validToPrefix: 'do',
      validFrom: 'Ważna od',
      validFromPlaceholder: 'Wybierz datę ważności od',
      validTo: 'Ważna do',
      validToPlaceholder: 'Wybierz datę ważności do',
      status: 'Status',
      actions: 'Akcje',
      remove: 'Usuń',
      assign: 'Przypisz',
      restore: 'Przywróć',
      update: 'Edytuj',
      showOn: 'Widoczna na',
      articles: 'Produkty',
      expandAllStores: 'Rozwiń wszystkie sklepy',
      shrinkAllStores: 'Ukryj wszystkie sklepy'
    },
    syncLongUrl: {
      button: 'Synchronizuj linki',
      title: 'Synchronizuj linki',
      submit: 'Synchronizuj',
      newSync: 'Nowa synchronizacja',
      processing: 'Przetwarzanie...',
      processingHint: 'Synchronizacja może potrwać do minuty. Proszę czekać.',
      runDryRun: 'Uruchom test',
      dryRunComplete: 'Test zakończony',
      syncComplete: 'Synchronizacja zakończona',
      proceedWithSync: 'Kontynuuj synchronizację',
      rerunDryRun: 'Ponów test',
      rerunWithSameSettings: 'Ponów z tymi samymi ustawieniami',
      backToForm: 'Wróć do formularza',
      form: {
        sheetUrl: 'URL arkusza Google',
        sheetUrlPlaceholder: 'https://docs.google.com/spreadsheets/d/...',
        syncScope: 'Zakres synchronizacji',
        syncAll: 'Synchronizuj wszystkie',
        syncByLeaflet: 'Synchronizuj po Natural ID gazetki',
        leafletNaturalId: 'Natural ID gazetki',
        leafletPlaceholder: 'Wyszukaj gazetkę...',
        syncStatus: 'Status synchronizacji',
        dryRun: 'Tryb testowy (Dry Run)',
        dryRunHint: 'Wykonaj symulację bez wprowadzania zmian',
        override: 'Zastąp istniejące dane',
        overrideHint: 'Wymuś zastąpienie istniejących danych podczas synchronizacji'
      },
      syncStatus: {
        readyToSync: 'READY_TO_SYNC',
        empty: 'Brak filtra (puste)',
        pending: 'PENDING',
        processed: 'PROCESSED',
        failed: 'FAILED',
        invalid: 'INVALID',
        unprocessable: 'UNPROCESSABLE'
      },
      validation: {
        sheetUrlRequired: 'URL arkusza Google jest wymagany',
        sheetUrlInvalid: 'Podaj prawidłowy URL arkusza Google',
        leafletRequired: 'Natural ID gazetki jest wymagany'
      },
      errors: {
        syncFailed: 'Synchronizacja nie powiodła się'
      },
      result: {
        title: 'Synchronizacja zakończona',
        sheetUrl: 'Arkusz Google',
        totalRows: 'Łączna liczba wierszy',
        processed: 'Przetworzono',
        failed: 'Niepowodzenia',
        unprocessable: 'Niemożliwe do przetworzenia',
        postponed: 'Odroczone',
        superseded: 'Zastąpione',
        expired: 'Wygasłe',
        rowIndex: 'Wiersz',
        leafletId: 'ID gazetki',
        type: 'Typ',
        page: 'Strona',
        message: 'Wiadomość',
        reason: 'Powód'
      }
    }
  },
  selectiveNotifications: {
    addNotification: 'Dodaj powiadomienie',
    notificationId: 'Identyfikator',
    plannedTime: 'Zaplanowany czas',
    channel: 'Kanał',
    devices: 'Platformy',
    title: 'Tytuł',
    saveSuccess: 'Powiadomienie zostało zapisane',
    deleteSuccess: 'Powiadomienie zostało usunięte',
    deleteConfirm: 'Czy na pewno chcesz usunąć to powiadomienie?'
  },
  navbar: {
    logOut: 'Wyloguj',
    dashboard: 'Tablica',
    screenfull: 'Fullscreen',
    theme: 'Theme',
    password: 'Zmień hasło',
    archives: 'Archiwa',
    inserts: 'Inserty',
    logs: 'Logi',
    xmlOffers: 'Kolejność gazetek',
    leaflets: 'Gazetki',
    version: 'wersja'
  },
  login: {
    title: 'Formularz logowania',
    logIn: 'Zaloguj',
    username: 'Użytkownik',
    password: 'Hasło'
  },
  theme: {
    change: 'Zmiana stylu'
  },
  users: {
    expandedRow: {
      cooks: 'KUCHARZE: ',
      stores: 'SKLEPY: '
    },
    enable: {
      button: 'Aktywuj',
      success: 'Status został zmieniony'
    },
    disable: {
      button: 'Dezaktywuj',
      success: 'Status został zmieniony'
    },
    fetchData: 'Ładowanie danych..',
    id: 'ID',
    role: 'Rola',
    actions: 'Akcje',
    username: 'Użytkownik',
    enabled: 'Aktywny',
    disabled: 'Nieaktywny',
    availableShops: 'Dostępne sklepy',
    assignedShops: 'Przypisane sklepy',
    availableCooks: 'Dostępni kucharze',
    assignedCooks: 'Przypisani kucharze',
    availableReelChannels: 'Dostępne kanały',
    assignedReelChannels: 'Przypisane kanały',
    availablePolicies: 'Dostępne polityki',
    assignedPolicies: 'Przypisane polityki',
    assignAlertForAdmins:
      'Administrator posiada dostęp do wszystkich sklepów, kucharzy i kanałów z rolkami. Zarządzanie dostępem jest niepotrzebne.',
    update: {
      title: 'Edytuj użytkownika',
      button: 'Zaktualizuj',
      success: 'Użytkownik został zaktualizowany',
      error: 'Użytkownik nie został zaktualizowany'
    },
    create: {
      title: 'Utwórz użytkownika',
      username: 'Nazwa użytkownika',
      password: 'Hasło',
      role: 'Typ konta',
      pickRole: 'Wybierz role',
      cancel: 'Anuluj',
      button: 'Utwórz użytkownika',
      success: 'Użytkownik został utworzony',
      shopFilterPlaceholder: 'Wyszukaj sklep',
      cooksFilterPlaceholder: 'Wyszukaj kucharza',
      reelChannelsPlaceholder: 'Wyszukaj kanał',
      policiesFilterPlaceholder: 'Wyszukaj politykę',
      stores: 'Sklepy',
      cooks: 'Kucharze',
      notificationChannels: 'Kanały',
      reelChannels: 'Kanały z rolkami',
      productPanelPolicies: 'Polityki panelu produktów'
    },
    remove: {
      button: 'Usuń',
      confirm: 'Czy na pewno chcesz usunąć użytkownika?',
      success: 'Użytkownik został usunięty'
    },
    changePassword: {
      button: 'Zmień hasło',
      dialogTitle: 'Zmień hasło użytkownika {name}',
      success: 'Hasło zostało zmienione.'
    },
    stores: 'Sklepy',
    rules: {
      username: 'Nazwa użytkownika jest wymagana i musi mieć więcej niż 3 znaki',
      usernameLowercase: 'Nazwa użytkownika może zawierać tylko małe litery',
      role: 'Typ konta jest wymagany',
      notificationChannels: 'Co najmniej jeden kanał jest wymagany',
      policyIds: 'Co najmniej jedna polityka jest wymagana dla roli PRODUCTS_VIEWER'
    },
    policyDetails: {
      title: 'Szczegóły polityki',
      brands: 'Marki',
      categories: 'Kategorie',
      countries: 'Kraje',
      stores: 'Sklepy',
      all: 'Wszystkie',
      close: 'Zamknij'
    },
    policyManagement: {
      title: 'Zarządzaj politykami dla Panelu Produktowego',
      manageButton: 'Zarządzaj politykami dla Panelu Produktowego',
      createTitle: 'Utwórz nową politykę',
      editTitle: 'Edytuj politykę',
      createButton: 'Utwórz politykę',
      editButton: 'Edytuj',
      deleteButton: 'Usuń',
      saveButton: 'Zapisz',
      cancelButton: 'Anuluj',
      nameLabel: 'Nazwa polityki',
      namePlaceholder: 'Wpisz nazwę polityki',
      brandsLabel: 'Marki',
      brandsPlaceholder: 'Wybierz lub utwórz marki',
      categoriesLabel: 'Kategorie',
      categoriesPlaceholder: 'Wybierz kategorie',
      allCategories: 'Wszystkie kategorie (*)',
      countriesLabel: 'Kraje',
      countriesPlaceholder: 'Wybierz kraje',
      storesLabel: 'Sklepy',
      storesPlaceholder: 'Wybierz lub utwórz sklepy',
      deleteConfirmTitle: 'Usuń politykę',
      deleteConfirmMessage: 'Czy na pewno chcesz usunąć tę politykę? Tej czynności nie można cofnąć.',
      deleteConfirmButton: 'Usuń',
      createSuccess: 'Polityka została utworzona pomyślnie',
      updateSuccess: 'Polityka została zaktualizowana pomyślnie',
      deleteSuccess: 'Polityka została usunięta pomyślnie',
      saveError: 'Nie udało się zapisać polityki',
      deleteError: 'Nie udało się usunąć polityki',
      deleteConflictError: 'Nie można usunąć polityki. Jest przypisana do jednego lub więcej użytkowników.',
      fetchError: 'Nie udało się pobrać polityk',
      validation: {
        nameRequired: 'Nazwa polityki jest wymagana',
        nameMinLength: 'Nazwa polityki musi mieć co najmniej 3 znaki',
        nameMaxLength: 'Nazwa polityki nie może przekraczać 255 znaków',
        brandsRequired: 'Wymagana jest co najmniej jedna marka',
        categoriesRequired: 'Wymagana jest co najmniej jedna kategoria',
        countriesRequired: 'Wymagany jest co najmniej jeden kraj',
        storesRequired: 'Wymagany jest co najmniej jeden sklep',
        validationFailed: 'Walidacja nie powiodła się'
      },
      countries: {
        all: 'Wszystkie (*)',
        pl: 'Polska (pl)',
        by: 'Białoruś (by)',
        cz: 'Czechy (cz)',
        lt: 'Litwa (lt)',
        ro: 'Rumunia (ro)',
        sk: 'Słowacja (sk)',
        ua: 'Ukraina (ua)'
      }
    },
    userCreate: {
      button: 'Dodaj użytkownika',
      enabled: 'Aktywny'
    }
  },
  groups: {
    tableLabel: {
      id: 'ID',
      name: 'Nazwa',
      actions: 'Akcje'
    },
    update: {
      button: 'Edytuj'
    },
    remove: {
      button: 'Usuń',
      confirm: 'Czy na pewno chcesz usunąć tą grupę?',
      success: 'Grupa została usunięta.'
    },
    addGroup: {
      title: 'Dodaj nową grupę',
      name: 'Nazwa: ',
      cancelButton: 'Anuluj',
      success: 'Grupa została utworzona.',
      button: 'Dodaj grupę'
    },
    editGroup: {
      title: 'Edytuj grupę',
      button: 'Zapisz zmiany',
      success: 'Grupa została zaktualizowana.'
    },
    rules: {
      name: {
        required: 'Nazwa grupy jest wymagana'
      }
    }
  },
  shops: {
    unmatchedLeaflets: 'Niepotwierdzone gazetki',
    fetchData: 'Ładowanie sklepów..',
    id: 'ID',
    update: 'Zaktualizuj sklep',
    editors: 'Edytorzy',
    available: 'Dostępni',
    add: 'Dodaj sklep',
    remove: {
      button: 'Usuń',
      confirm: 'Czy na pewno chcesz usunąć ten sklep?',
      success: 'Sklep został usunięty'
    },
    filterByInactive: 'Tylko nieaktywne',
    activateAllLeaflets: 'Aktywuj wszystkie gazetki',
    showShopLeaflets: 'Rozwiń gazetki',
    shrinkShopLeaflets: 'Zwiń gazetki',
    shopCreate: {
      title: 'Dodaj sklep',
      cancel: 'Anuluj',
      confirm: 'Dodaj sklep',
      name: 'Nazwa',
      storeWebId: 'Nazwa Id',
      update: 'Zaktualizuj sklep',
      category: 'Kategoria',
      pickCategory: 'Wybierz kategorie',
      salesModels: {
        label: 'Model sprzedaży',
        placeholder: 'Wybierz model sprzedaży',
        options: {
          retail: 'Detaliczny',
          wholesale: 'Hurtowy'
        }
      },
      ownBrandIds: 'Id własnych marek',
      ownBrandIdsPlaceholder: 'Dodaj id własnych marek',
      success: 'Sklep został utworzony',
      logos: {
        title: 'Logotypy sklepu',
        current: 'Aktualne logo',
        light: {
          label: 'Logo dla jasnego trybu',
          upload: 'Naciśnij lub upuść plik, aby dodać jasne logo'
        },
        dark: {
          label: 'Logo dla ciemnego trybu (opcjonalne)',
          upload: 'Naciśnij lub upuść plik, aby dodać ciemne logo',
          fallback: 'Jeśli go nie dodasz, aplikacja użyje logo dla jasnego trybu.'
        }
      },
      forceFavorites: {
        description: 'Ulubiony sklep',
        details: 'Sklep pojawi się u każdego użytkownika jako Ulubiony'
      },
      showAnyway: {
        details: 'Jeżeli użytkownik, ukryje ten sklep to nadal zostanie on pokazany w aplikacji',
        description: 'Pokaż gazetki mimo ukrycia'
      },
      storeAtFirst: {
        details: 'Zostanie umieszczony na początku listy na stronie Sklepy w aplikacji',
        description: 'Pokaż na początku listy'
      },
      addAsReelsChannel: {
        details: 'Sklep będzie pokazywany u góry aplikacji w reelsach',
        description: 'Dodaj jako kanał'
      },
      shouldAutoProcessLeaflets: {
        description: 'Automatyczne cięcie gazetek',
        details: 'Gdy flaga jest zaznaczona, to gazetka zostaje automatycznie pocięta po dodaniu'
      },
      editors: 'Wybierz, kto powinien mieć dostęp do sklepu',
      rules: {
        name: 'Nazwa jest wymagana',
        storeWebId: 'Nazwa Id jest wymagana',
        storeWebIdText: 'Nazwa Id może się składać tylko z małych liter, cyfr oraz znaku "-"',
        storeNameDuplicate: 'Istnieje już sklep o nazwie {name}',
        geolocations: 'Każdy wiersz musi mieć format lat,lng,promień. Przekonwertuj adresy za pomocą różdżki.',
        category: 'Kategoria jest wymagana',
        salesModels: 'Wybierz co najmniej jeden model sprzedaży'
      }
    },
    deleteLinks: {
      selectPlaceholder: 'Wybierz linki do usunięcia',
      confirm: 'Czy na pewno chcesz usunąć linki z tego sklepu?',
      success: 'Linki zostały usunięte.'
    },
    shopUpdate: {
      title: 'Zaktualizuj sklep',
      success: 'Sklep został zaktualizowany'
    }
  },
  password: {
    currentPassword: 'Aktualne hasło',
    newPassword: 'Nowe hasło',
    newPasswordRepeat: 'Powtórz nowe hasło',
    submitPassword: 'Zmień hasło',
    reset: 'Zresetuj formularz',
    rules: {
      minLength: 'Hasło jest wymagane i musi mieć więcej niż {minLength} znaków'
    }
  },
  leaflets: {
    addToSystem: 'Dodaj do systemu',
    dataSync: {
      message: 'Dane gazetek są aktualizowane w tle. Zawartość strony może różnić się od danych na serwerze.'
    },
    validation: {
      errorInLeafletId: 'w gazetce ID'
    },
    readyForActivation: 'Gazetki gotowe do publikacji',
    readyForDisactivation: 'Gazetki gotowe do usunięcia',
    fetchData: 'Ładowanie gazetek..',
    untilEndOfSupply: 'Do wyczerpania zapasów',
    naturalId: 'ID',
    validFrom: 'Od',
    validTo: 'Do',
    priority: 'Pozycja',
    refresh: {
      button: 'Odśwież gazetkę',
      success: 'Data została odświeżona.',
      confirm: 'Czy na pewno chcesz odświeżyć gazetkę?'
    },
    activateStatusDate: 'Data aktywacji',
    additionalInfo: 'Tytuł',
    additionalInfoMissing: '[nie dodano tytułu]',
    additionalInfo2: 'Podtytuł 2',
    longUrl: 'URL',
    thumbnailTrackingUrl: 'Zliczający miniaturki URL',
    thumbnailTrackingUrlConfirm: 'Dodałeś link zliczający wyświetlenia miniaturek (nie otwarcie gazetki)',
    redirectUrl: 'Przekierowanie URL',
    status: 'Status',
    actions: 'Akcje',
    actionMenu: {
      edit: 'Edytuj gazetkę',
      showInDashboard: 'Pokaż w dashboardzie'
    },
    update: 'Zaktualizuj',
    add: 'Dodaj gazetkę',
    goToPageDetails: 'Przekierowania i inserty',
    activate: 'Aktywuj',
    details: 'Szczegóły',
    publishDate: 'Data publikacji',
    createdBy: 'Dodana przez',
    activateReadyStatusAt: 'Odświeżono',
    refreshedBy: 'Odświeżona przez',
    products: {
      geolocation: {
        label: 'Geolokalizacja',
        description:
          'Ustal, z jakimi domyślnymi ustawieniami dotyczącymi geolokalizacji będą dodawane gazetki tego sklepu.',
        options: {
          notGeolocalized: {
            description: 'Niegeolokalizowane',
            details: 'Widoczna dla każdej lokalizacji'
          },
          geolocalizedDependingOnStore: {
            description: 'Geolokalizowana według lokalizacji sklepu',
            details: 'Widoczna w okolicy sklepu (baza adresów - np. crawlery)'
          },
          geolocalizedDependingOnAreas: {
            description: 'Geolokalizowana według obszarów',
            details: 'Widoczna w obrębie ustawionych obszarów'
          }
        },
        showToUserWithNoLocation: {
          description: 'Wyświetl użytkownikom bez ustawionej lokalizacji',
          details: 'Gazetka będzie widoczna także dla użytkowników, którzy nie podali swojej lokalizacji'
        },
        areas: {
          label: 'Lista obszarów (lat/lng/rad)',
          description:
            'Każdy adres lub obszar w nowym wierszu. Użyj różdżki, aby zamienić adresy na współrzędne. Promień podany w metrach.',
          placeholder: 'Warszawa\n51.4141,16.55551,100'
        },
        availableAreas: {
          label: 'Lokalizacje wyświetlania (lat/lng/rad)',
          description:
            'Gazetka będzie widoczna w tych obszarach. Każdy adres lub obszar wpisz w nowym wierszu. Promień podany w metrach.',
          placeholder: 'Warszawa\n51.4141,16.55551,100'
        },
        unavailableAreas: {
          label: 'Lokalizacje wykluczone (lat/lng/rad)',
          description:
            'Gazetka nie będzie widoczna w tych obszarach. Każdy adres lub obszar wpisz w nowym wierszu. Promień podany w metrach.',
          placeholder: 'Kraków\n50.0647,19.945,500'
        },
        geocode: {
          tooltip: 'Zamień adresy na współrzędne',
          ariaLabel: 'Geokoduj wpisane adresy',
          success: 'Przekonwertowano adresy: {count}',
          partialSuccess: 'Przekonwertowano {converted} adresów. Nie rozpoznano: {failed}.',
          failure: 'Nie udało się rozpoznać adresów: {count}.'
        },
        map: {
          ariaLabel: 'Podgląd obszarów geolokalizacji na mapie',
          empty: 'Mapa pojawi się po wpisaniu współrzędnych lub przekonwertowaniu adresu.',
          legend: {
            ariaLabel: 'Legenda dostępności obszarów',
            available: 'Wyświetlaj',
            unavailable: 'Ukryj'
          }
        }
      },
      button: 'Produkty',
      fetchError: 'Błąd podczas pobierania danych produktów',
      count: 'produkty',
      nameLabel: 'Nazwa',
      brandLabel: 'Marka',
      manufacturerLabel: 'Producent',
      manufacturerSourceLabel: 'Źródło informacji',
      manufacturerSources: {
        printed: 'Gazetka',
        package: 'Opakowanie',
        knowledge: 'Wiedza'
      },
      variantLabel: 'Wariant',
      packagingLabel: 'Opakowanie',
      packagingTypeLabel: 'Typ opakowania',
      packagingSubtypeLabel: 'Podtyp opakowania',
      packCountLabel: 'Liczba sztuk w opakowaniu',
      unitSizeLabel: 'Wielkość jednostki',
      coordsLabel: 'Współrzędne',
      actions: 'Akcje',
      edit: 'Edytuj',
      duplicate: 'Duplikuj',
      addArticle: 'Dodaj Artykuł',
      createArticle: 'Utwórz Artykuł',
      updateArticle: 'Aktualizuj Artykuł',
      priceLabel: 'Cena',
      currencyLabel: 'Waluta',
      mapPriceLabel: 'Cena promocyjna',
      crossedPriceLabel: 'Cena przekreślona',
      pricePerUnitLabel: 'Cena za jednostkę',
      pricePerUnitBasisLabel: 'Podstawa ceny jednostkowej',
      unitLabel: 'Jednostka',
      discountLabel: 'Zniżka',
      lowestPrice30DaysLabel: 'Najniższa cena z 30 dni',
      depositLabel: 'Kaucja',
      multibuyLabel: 'Zakup wielosztukowy',
      multibuyTypeLabel: 'Rodzaj promocji wielosztukowej',
      multibuyTextLabel: 'Warunki promocji wielosztukowej',
      sizeOptionsLabel: 'Warianty rozmiaru',
      specsTextLabel: 'Specyfikacja',
      soldByLabel: 'Sposób sprzedaży',
      loyaltyProgramLabel: 'Program lojalnościowy',
      conditionTextLabel: 'Warunki oferty',
      minQtyLabel: 'Minimalna ilość',
      limitLabel: 'Limit zakupu',
      blockCountLabel: 'Liczba bloków promocyjnych',
      reviewReasonsLabel: 'Powody do weryfikacji',
      addSizeOption: 'Dodaj wariant rozmiaru',
      removeSizeOption: 'Usuń wariant rozmiaru',
      noSizeOptions: 'Brak wariantów rozmiaru',
      sections: {
        basic: 'Dane podstawowe',
        pricing: 'Ceny i promocja',
        packaging: 'Opakowanie i sprzedaż',
        conditions: 'Warunki oferty',
        quality: 'Kontrola jakości'
      },
      keywordsLabel: 'Słowa kluczowe',
      keywordsPlaceholder: 'Wpisz słowo kluczowe',
      addKeyword: 'Dodaj słowo',
      createKeywordConfirmTitle: 'Utwórz nowy keyword',
      createKeywordConfirmMessage: 'Czy chcesz utworzyć nowy keyword „{keyword}”?',
      createKeywordSuccess: 'Nowy keyword został utworzony',
      createKeywordError: 'Nie udało się utworzyć nowego keywordu',
      keywordsFetchError: 'Nie udało się pobrać aktywnych keywordsów',
      invalidKeyword: 'Keyword musi mieć od 1 do 100 znaków',
      multipleKeywordsUnsupported: 'Dodawaj nowe keywordsy pojedynczo',
      ownBrandLabel: 'Marka własna',
      promotedLabel: 'Promowany',
      flagEnabled: 'Tak',
      flagDisabled: 'Nie',
      categoriesLabel: 'Kategorie',
      categoriesPlaceholder: 'Wybierz kategorie',
      categoriesRemovedOnSave: 'Zapis oferty usunie kategorie nieaktywne i nieznane: {names}',
      createSuccess: 'Artykuł został utworzony pomyślnie',
      createError: 'Nie udało się utworzyć artykułu',
      updateSuccess: 'Artykuł został zaktualizowany pomyślnie',
      updateError: 'Nie udało się zaktualizować artykułu',
      deleteSuccess: 'Artykuł został usunięty pomyślnie',
      deleteError: 'Nie udało się usunąć artykułu',
      deleteConfirmTitle: 'Usuń Artykuł',
      deleteConfirmMessage: 'Czy na pewno chcesz usunąć artykuł "{name}"? Ta akcja nie może być cofnięta.',
      updateSelection: 'Zmień zaznaczenie',
      finishSelection: 'Zakończ zaznaczanie',
      drawingModeText: 'TRYB ZAZNACZANIA - Kliknij i przeciągnij aby zaznaczyć obszar',
      editArea: 'Edytuj obszar',
      drawAreaInstructions: 'Kliknij i przeciągnij aby zaznaczyć obszar na zdjęciu',
      areaUpdated: 'Współrzędne obszaru zostały zaktualizowane pomyślnie',
      roboflow: {
        addToTraining: 'Wyślij do trenowania',
        addSuccess: 'Strona {pageNumber} została dodana do kolejki danych treningowych.',
        addError: 'Nie udało się dodać strony do kolejki danych treningowych.'
      },
      recutPage: {
        button: 'Ponów cięcie strony',
        confirmTitle: 'Ponowić cięcie strony?',
        confirmMessage:
          'Ponowne cięcie strony {pageNumber} może zastąpić znajdujące się na niej produkty i ręczne poprawki.',
        confirmButton: 'Ponów cięcie strony',
        success: 'Żądanie ponownego cięcia strony {pageNumber} zostało wysłane.',
        error: 'Nie udało się ponowić cięcia strony {pageNumber}.'
      },
      validation: {
        manufacturerRequired: 'Podaj producenta dla wybranego źródła',
        manufacturerSourceRequired: 'Wybierz źródło informacji o producencie',
        labelRequired: 'Nazwa jest wymagana',
        areaRequired: 'Proszę zaznaczyć obszar na obrazie przed utworzeniem artykułu',
        validToBeforeValidFrom: 'Data ważności do nie może być wcześniejsza niż data ważności od',
        coordsRequired: 'Współrzędne są wymagane',
        pageNumberMin: 'Numer strony musi być większy niż 0',
        pageNumberInteger: 'Numer strony musi być liczbą całkowitą',
        pageNumberRequired: 'Numer strony jest wymagany',
        dateRange: 'Data ważności od nie może być późniejsza niż data ważności do',
        genericError: 'Wystąpił błąd walidacji'
      },
      categoryLabel: 'Kategoria',
      title: 'Dane dotyczące artykułów'
    },
    remove: {
      button: 'Usuń',
      confirm: 'Czy na pewno chcesz usunąć tą gazetkę?',
      success: 'Gazetka została usunięta'
    },
    clipboard: {
      copyConfig: 'Kopiuj konfigurację',
      pasteConfig: 'Wklej konfigurację',
      copySuccess: 'Konfiguracja gazetki została skopiowana',
      copyError: 'Nie udało się skopiować konfiguracji gazetki',
      pasteSuccess: 'Konfiguracja gazetki została wklejona',
      pasteError: 'Nie udało się wkleić konfiguracji gazetki'
    },
    openPageDetailsImages: 'Podgląd stron',
    zipCodes: 'Kod pocztowy',
    pageCount: 'Strony',
    statusList: {
      INACTIVE: 'Nieaktywna',
      READY_FOR_ACTIVATION: 'Gotowa na aktywacje',
      ACTIVE: 'Aktywna',
      READY_FOR_DISACTIVATION: 'Gotowa na dezaktywacje',
      DELETED: 'Usunięta'
    },
    pageDetailsImages: {
      title: 'Podgląd zdjęć gazetki',
      pageNumber: 'Numer strony:',
      dimensions: 'Wymiar:',
      size: 'Rozmiar:'
    },
    organizePages: {
      title: 'Organizuj Strony',
      description: 'Przeglądaj i organizuj strony tej gazetki. Strony są wyświetlane w aktualnej kolejności.',
      downloadInfo:
        'Aby przesłać strony w innej kolejności, pobierz wszystkie obrazy, a następnie prześlij je w zakładce "Prześlij nową gazetkę".',
      pageNumber: 'Strona {number}',
      pagePreview: 'Podgląd strony {number}',
      noPages: 'Nie znaleziono stron dla tej gazetki',
      noLeafletId: 'Nie podano ID gazetki',
      fetchError: 'Nie udało się pobrać szczegółów stron',
      error: 'Błąd podczas ładowania stron'
    },
    uploadWrapper: {
      uploadNewLeaflet: 'Prześlij nową gazetkę',
      organizePages: 'Organizuj strony'
    },
    rules: {
      naturalId: 'Unikatowa nazwa jest wymagana',
      validFrom: 'Data od kiedy jest wymagana',
      validTo: 'Data do kiedy jest wymagana',
      validToExpired: 'Data ważności gazetki już minęła. Upewnij się, że wprowadzasz poprawną datę.',
      validToBeforeValidFrom: 'Data ważności do nie może być wcześniejsza niż data ważności od',
      publishDate: 'Data publikacji jest wymagana',
      publishDateIsFromThePast: 'Data publikacji nie może być datą z przeszłości',
      active: 'Stan gazetki jest wymagany',
      file: 'Przynajmniej jeden plik jest wymagany',
      priority: 'Pozycja powinna być liczbą naturalną, maksymalnie 3 cyfrową',
      numberOfImages: 'Ilość linków musi być liczbą naturalną.',
      geolocations: 'Każdy wiersz musi mieć format lat,lng,promień. Przekonwertuj adresy za pomocą różdżki.',
      socialMediaUrl: 'Podaj prawidłowy adres URL',
      scheduledEventIncomplete: 'Zaplanowana podmiana jest niekompletna'
    },
    uploadFiles: {
      select: 'Naciśnij lub upuść plik aby zuploadować',
      send: 'Wyślij',
      wrongFile: 'Zły typ pliku',
      tooManyPdfs: 'Możesz dodać tylko jeden plik PDF',
      wrongId: 'Czy na pewno chcesz dodać pdf z Nazwa Id inna niż',
      firstPage: 'Naciśnij lub upuść plik aby zmienić okładkę',
      outdatedPdf: 'Daty zdefiniowane w pliku pdf są w przeszłości. Nazwij plik poprawnie lub wprowadź poprawne daty'
    },
    leafletsCreate: {
      title: 'Dodaj gazetkę',
      crawlerTitle: 'Dodaj szkic gazetki',
      naturalId: 'ID',
      validFrom: {
        label: 'Od',
        placeholder: 'Wpisz date'
      },
      button: 'Utwórz',
      group: 'Grupa',
      newGroup: 'Nowa',
      additionalOptions: 'Dodatkowe opcje',
      hasRecipe: 'Ma przepis',
      category: {
        label: 'Ustaw inną kategorię',
        placeholder: 'Domyślna'
      },
      publishDate: {
        label: 'Publikacja',
        placeholder: 'Wybierz datę i godzinę'
      },
      publishEndDate: {
        label: 'Publikuj do',
        placeholder: 'Wybierz datę i godzinę'
      },
      validTo: {
        label: 'Do',
        placeholder: 'Wpisz date',
        checkbox: 'Do wyczerpania zapasów'
      },
      showOn: {
        label: 'Widoczna na',
        android: 'Android',
        androidMG: 'Moja Gazetka (Android)',
        androidMP: 'mPromocje (Android2)',
        iOS: 'iOS',
        ios: 'iOS',
        web: 'Web',
        wp: 'WP',
        all: 'Wszystkie platformy',
        android2: {
          'dev-1-pl': 'mPromocje',
          'dev-1-ua': 'Love Sales Light',
          'preprod-pl': 'mPromocje',
          'preprod-ua': 'Love Sales Light',
          'local': 'mPromocje',
          'pl': 'mPromocje',
          'ua': 'Love Sales Light'
        }
      },
      leaflet: 'Gazetka',
      pdfURL: 'Link do pdf',
      imagesURLPattern: 'Wzrór linku',
      numberOfImages: 'Ilość linków',
      advanced: 'Zaawansowane',
      lastPageInsert: 'Generuj insert "Oceń"',
      adultsOnly: {
        label: 'Gazetka dla pełnoletnich',
        hint: 'Gazetka dla pełnoletnich jest widoczna tylko w {platform}',
        hintNoPlatform: 'Gazetka dla pełnoletnich nie jest widoczna na żadnej platformie',
        badge: 'Tylko dla 18+'
      },
      showOnlineBadge: 'Oznacz jako online',
      showPopularBadge: 'Oznacz jako ‘Popularna’',
      addWatermark: 'Dodaj watermark',
      previewFilesShow: 'Pokaż plików: {number}',
      hideFilesShow: 'Ukryj {number} plików',
      notAllowShoppingList: 'Wyłącz listę zakupów',
      notShowAdInserts: 'Wyłącz inserty reklamowe',
      forceLast: 'Umieść na końcu listy',
      redirectUrl: 'Przekierowanie URL',
      zipCodes: 'Kod pocztowy',
      additionalInfo: 'Podtytuł 1',
      additionalInfo2: 'Podtytuł 2',
      socialMedia: {
        label: 'Media społecznościowe',
        youtube: 'YouTube URL',
        youtubePlaceholder: 'https://www.youtube.com/watch?v=...',
        tiktok: 'TikTok URL',
        tiktokPlaceholder: 'https://www.tiktok.com/...',
        platform: 'Platforma',
        url: 'URL',
        addNewLink: 'Dodaj nowy link',
        remove: 'Usuń',
        duplicateUrl: 'Ten URL został już dodany'
      },
      replaceValidity: {
        text: 'Zastąp tekst dot. obowiązywania',
        isNull: 'Bez zmian',
        isEmpty: 'Puste'
      },
      longUrl: 'Zliczający URL',
      thumbnailTrackingUrl: 'Zliczający miniaturki URL',
      status: {
        label: 'Status'
      },
      confirm: 'Utwórz',
      success: 'Gazetka została utworzona',
      multipleLeafletsSuccess: 'Liczba utworzonych gazetek: {number}',
      multipleLeafletsFailure: 'Nie udało się utworzyć niektórych gazetek',
      uploadingFiles: 'Wysyłanie plików...',
      generatingImages: 'Generowanie obrazów...',
      generationTimeout: 'Generowanie obrazów trwa zbyt długo',
      generationFailed: 'Nie udało się wygenerować obrazów',
      invalidTabs: 'Niektóre zakładki zawierają niepoprawne lub brakujące dane',
      error: 'Gazetka nie została utworzona',
      update: 'Zaktualizuj',
      cancel: 'Anuluj',
      invalidTab: 'Niepoprawny',
      priorityLabels: {
        android: 'Android pozycja',
        ios: 'IOS pozycja',
        web: 'Web pozycja',
        wp: 'WP pozycja',
        android2: {
          'dev-1': 'mPromocje pozycja',
          'preprod': 'mPromocje pozycja',
          'preprod-pl': 'mPromocje pozycja',
          'local': 'mPromocje pozycja',
          'pl': 'mPromocje pozycja',
          'ua': 'Love Sales Light pozycja'
        }
      }
    },
    leafletsUpdate: {
      title: 'Zaktualizuj gazetke',
      success: 'Gazetka została zaktualizowana',
      error: 'Gazetka została nie zaktualizowana',
      button: 'Zaktualizuj',
      overwritePriority:
        'Pozycja {priorityNumber} jest już ustawiony dla gazetki z id: {leafletId}. Chcesz podjąć próbę nadpisania pozycji?',
      overwritePriorities:
        'Dla {leafletsCount} platform istnieje już inna gazetka z pozycją {priorityNumber}. Czy chcesz podjąć próbę nadpisania wszystkich konfliktowych pozycji?',
      coverUpdated: 'Okładka gazetki została zaktualizowana'
    }
  },
  leafletPageDetails: {
    sharedDialogs: {
      pageCount: 'Ilość stron: {numberOfPages}',
      cancel: 'Anuluj',
      positionNumber: 'Numer pozycji',
      positionNumbers: 'Numery pozycji',
      description: 'Opis wyświetlany',
      longUrl: 'Zliczający URL',
      redirectUrl: 'Przekierowanie URL',
      infoAlert:
        'Numery pozycji na których ma być dodany insert należy wpisać po przecinku (np. 1, 2, 3, 7) lub podać przedział (np. 5 - 12)',
      rules: {
        pageNumbersRequired: 'Numer pozycji jest wymagany',
        removeDuplicate: 'Lista zawiera zduplikowane pozycje',
        haveZero: 'Pozycja nie może być zerowa',
        allFieldsRequired: 'Wszystkie pola są wymagane',
        oneOfFieldsRequired: 'Co najmniej jedno pole musi być uzupełnione',
        dateFromPast: 'Nie można zaplanować podmiany linku z wsteczną datą',
        platformIsRequired: 'Platforma jest wymagana'
      }
    },
    insertDialog: {
      addTitle: 'Dodaj insert do {naturalId}',
      editTitle: 'Zaktualizuj insert w {naturalId}',
      addConfirm: 'Dodaj insert',
      editConfirm: 'Zaktualizuj',
      creationSuccess: 'Linki zostały utworzone',
      updateSuccess: 'Insert został zaktualizowany',
      overrideConfirm: 'Na tej stronie istnieje już insert. Czy na pewno chcesz go nadpisać?',
      insertId: {
        label: 'Insert ID',
        placeholder: 'Wybierz insert z listy'
      },
      rules: {
        insertIdRequired: 'Insert jest wymagany',
        valueOutOfRange: 'Podana pozycja jest większa od ilości stron gazetki + 1'
      }
    },
    redirectDialog: {
      addTitle: 'Dodaj przekierowanie do {naturalId}',
      editTitle: 'Zaktualizuj przekierowanie w {naturalId}',
      allPages: 'Dodaj linki do wszystkich stron',
      addConfirm: 'Dodaj przekierownie',
      editConfirm: 'Zaktualizuj',
      creationSuccess: 'Linki zostały utworzone',
      updateSuccess: 'Przekierowanie zostało zaktualizowane',
      schedule: {
        redirectUrl: 'Ustaw przekierowanie URL',
        thumbnailTrackingUrl: 'Ustaw zliczający miniaturki URL',
        longUrl: 'Ustaw zliczający URL',
        toDay: 'na dzień',
        selectDay: 'wybierz dzień',
        atHour: 'o godzinie',
        selectHour: 'wybierz godzinę',
        changeTo: 'zamień na',
        typeNewLink: 'podaj nowy link'
      },
      scheduledEvents: {
        planningSuccess: 'Podmiany linków zostały zaplanowane',
        redirectDeletionSuccess: 'Usunięto zaplanowaną podmianę linku przekierowywującego.',
        longDeletionSuccess: 'Usunięto zaplanowaną podmianę linku zliczającego.',
        thumbnailTrackingDeletionSuccess: 'Usunięto zaplanowaną podmianę linku zliczającego miniaturki.',
        deleteLongButton: 'Usuń zaplanowaną podmianę linku zliczającego',
        deleteRedirectButton: 'Usuń zaplanowaną podmianę linku przekierowywującego'
      },
      overrideConfirm: 'Na tej stronie istnieje już przekierowanie. Czy na pewno chcesz je nadpisać?',
      rules: {
        valueOutOfRange: 'Podana pozycja jest większa od ilości stron gazetki'
      }
    }
  },
  pageDetails: {
    fetchData: 'Ładowanie szczegółów stron..',
    description: 'Opis',
    insertImageURL: 'URL zdjęcia',
    insertName: 'Nazwa',
    pageNumber: 'Numer strony',
    positionNumber: 'Numer pozycji',
    redirectURL: 'Przekierowanie URL',
    scheduledLinkReplacement: 'Zaplanowana podmiana linku',
    links: 'Linki',
    date: 'Data',
    platforms: 'Platformy',
    longUrl: 'Zliczający URL',
    actions: 'Akcje',
    insertsFor: 'Inserty i przekierowania dla gazetki:',
    showOnlineBadgeUpdate: {
      trueMsg: 'Gazetka oznaczona jako online',
      falseMsg: 'Odznaczono status online dla gazetki'
    },
    leafletLinks: {
      longUrl: 'Zliczający URL gazetki',
      thumbnailTrackingUrl: 'Zliczający miniaturki URL Gazetki',
      edit: 'Edytuj',
      sync: 'Synchronizuj linki',
      empty: '—',
      dialogTitle: 'Edytuj linki gazetki',
      saveSuccess: 'Linki gazetki zostały zapisane',
      saveError: 'Nie udało się zapisać linków gazetki'
    },
    inserts: 'Inserty',
    redirects: 'Przekierowania',
    removeInsert: {
      button: 'Usuń',
      confirm: 'Czy na pewno chcesz usunąć insert z tej strony?',
      success: 'Insert został usunięty'
    },
    removeRedirect: {
      button: 'Usuń',
      confirm: 'Czy na pewno chcesz usunąć linki z tej strony?',
      success: 'Przekierowanie zostało usunięte'
    },
    removeAllRedirects: {
      button: 'Usuń wszystkie linki',
      confirm: 'Czy na pewno chcesz usunąć wszystkie linki z tej gazetki?',
      success: 'Linki zostały usunięte.'
    },
    linkCreate: {
      button: 'Dodaj link',
      title: 'Dodaj link do '
    },
    bulkLinkCreate: {
      button: 'Dodaj wiele linków',
      title: 'Dodaj wiele linków do',
      dialog: {
        descriptionLabel: 'Opis wyświetlany:',
        linksLabel: 'Linki:',
        linksPlaceholder: 'Tutaj wklej dane z edytora',
        addLinksBtn: 'Dodaj linki',
        cancelBtn: 'Anuluj'
      }
    },
    insertUpdate: {
      button: 'Zaktualizuj'
    },
    insertCreate: {
      button: 'Dodaj insert'
    },
    insertDeleteAll: {
      button: 'Usuń wszystkie inserty',
      confirm: 'Na pewno chcesz usunąć wszystkie inserty dla tej gazetki?',
      success: 'Wszystkie inserty zostały usunięte z gazetki'
    },
    leafletArea: {
      areasDefinition: 'Definiowanie obszarów',
      page: 'Strona: ',
      dimensions: 'Współrzędne',
      promotedProduct: 'Produkt promowany',
      promoted: 'Promowany',
      areas: 'obszary',
      link: 'Link',
      save: 'Zapisz',
      pageArea: 'Obszary',
      deleteAll: 'Usuń wszystkie',
      color: 'Kolor',
      actions: 'Akcje',
      cancel: 'Anuluj',
      deleteArea: {
        confirm: 'Na pewno usunąć obszar?',
        successMsg: 'Obszar pomyślnie usunięty'
      },
      deleteAllAreas: {
        confirm: 'Na pewno usunąć WSZYSTKIE obszary?',
        successMsg: 'Wszystkie obszary na {page} stronie zostały usunięte.'
      },
      affiliation: {
        selectPlaceholder: 'Brak afiliacji'
      },
      urlParameters: {
        label: 'Dodatkowe parametry URL'
      },
      linkRequired: 'Link jest wymagany',
      linkInvalid: 'Link jest nieprawidłowy',
      areaInvalid: 'Wybrany obszar jest nieprawidłowy, powinien mieć co najmniej 5 x 5 px',
      loadLinksFromPDF: {
        uploadButton: 'Wczytaj linkowanie z pliku PDF',
        uploadButtonPending: 'Trwa ładowanie pliku',
        successMsg: 'Linki z pliku PDF zostały wczytane',
        errorMsg: 'Błąd podczas wczytywania linkowania z pliku PDF',
        progressMsg: 'Trwa ładowanie linków z pliku PDF...'
      }
    }
  },
  newLeafletsSearch: {
    notifications: {
      createDraft: {
        success: 'Szkic gazetki został utworzony',
        error: 'Błąd podczas tworzenia szkicu gazetki'
      }
    },
    createDraftLeaflet: 'Utwórz gazetkę',
    selectStore: 'Wybierz sklep',
    fetching: 'Ładowanie danych...',
    noStoreSelected: 'Wybierz sklep, aby wyświetlić gazetki',
    noStoreSelectedDescription: 'Wybierz sklep z listy rozwijanej powyżej, aby zobaczyć dostępne gazetki',
    id: 'ID',
    status: 'Status',
    storeName: 'Nazwa sklepu',
    title: 'Tytuł',
    validFrom: 'Ważna od',
    validTo: 'Ważna do',
    numberOfPages: 'Liczba stron',
    url: 'Identyfikowana na podstawie',
    attachments: 'Załączniki',
    actions: 'Akcje',
    updatedAt: 'Ostatnia aktualizacja',
    runCrawler: {
      button: 'Crawluj ponownie',
      running: 'Trwa crawlowanie',
      pending: 'Oczekuje',
      queued: 'W kolejce do przetworzenia',
      processing: 'Przetwarzanie',
      started: 'Rozpoczęto',
      retrying: 'Ponowna próba',
      success: 'Pomyślnie rozpoczęto crawlowanie',
      error: 'Błąd podczas crawlowania'
    }
  },
  inserts: {
    fetchData: 'Ładowanie insertów..',
    add: 'Dodaj insert',
    description: 'Opis wyświetlany',
    redirectUrl: 'Przekierowanie URL',
    longUrl: 'Zliczający URL',
    showOn: 'Widoczny na',
    insertName: 'Nazwa',
    insertImage: 'Zdjęcie',
    actions: 'Akcje',
    searchPlaceholder: 'Wyszukaj inserty po nazwie',
    showUsed: 'Pokaż używane inserty',
    clearSearch: 'Wyczyść wyszukiwanie',
    noData: 'Brak insertów',
    noDataFound: 'Brak insertów znalezionych po tej frazie wyszukiwania',
    details: {
      deletion: {
        button: '. | Usuń insert z gazetki | Usuń insert z gazetek',
        success: 'Insert został usunięty ze wszystkich gazetek',
        failed: 'Nie udało się usunąć insertu z niektórych gazetek. Spróbuj ponownie.'
      },
      removeAllLeafletsTitle: 'Usuń wszystkie powiązania',
      removeAllLeafletsDescription:
        'Czy na pewno chcesz usunąć insert z wszystkich gazetek, do których jest on przypisany?',
      empty: 'Brak gazetek do wyświetlenia',
      fetch: {
        error: {
          title: 'Błąd podczas ładowania gazetek',
          description: 'Nie udało się pobrać danych gazetek. Spróbuj ponownie.'
        },
        partialError: {
          title: 'Niektóre gazetki nie mogły zostać załadowane',
          description: 'Niektóre gazetki nie zostały załadowane, ale pozostałe są wyświetlone poniżej.'
        }
      }
    },
    upload: {
      success: 'Insert został wysłany',
      failure: 'Insert nie został wysłany'
    },
    update: {
      title: 'Zaktualizuj insert',
      button: 'Zaktualizuj',
      success: 'Insert został zaktualizowany'
    },
    remove: {
      button: 'Usuń',
      confirm: 'Czy na pewno chcesz usunąć ten insert?',
      success: 'Insert został usunięty',
      failure: 'Insert jest używany w gazetkach:',
      blockedByUsage: 'Ten insert ma powiązania z gazetkami. Usuń powiązania przed usunięciem insertu.'
    },
    archive: {
      button: 'Archiwizuj',
      confirm: 'Czy na pewno chcesz archiwizować ten insert?',
      success: 'Insert został archiwizowany'
    },
    geolocation: {
      label: 'Geolokalizacja',
      enabled: {
        description: 'Geolokalizowany według obszarów',
        details: 'Insert będzie widoczny zgodnie z ustawionymi obszarami'
      },
      availableAreas: {
        label: 'Lokalizacje wyświetlania (lat/lng/rad)',
        description:
          'Insert będzie widoczny w tych obszarach. Każdy adres lub obszar wpisz w nowym wierszu. Promień podany w metrach.',
        placeholder: 'Warszawa\n51.4141,16.55551,100'
      },
      unavailableAreas: {
        label: 'Lokalizacje wykluczone (lat/lng/rad)',
        description:
          'Insert nie będzie widoczny w tych obszarach. Każdy adres lub obszar wpisz w nowym wierszu. Promień podany w metrach.',
        placeholder: 'Kraków\n50.0647,19.945,500'
      }
    },
    insertCreate: {
      title: 'Dodaj insert',
      description: 'Opis wyświetlany',
      redirectUrl: 'Przekierowanie URL',
      longUrl: 'Zliczający URL',
      validDates: 'Daty ważności',
      validFrom: {
        label: 'Ważny od',
        placeholder: 'Wybierz datę początkową'
      },
      validTo: {
        label: 'Ważny do',
        placeholder: 'Wybierz datę końcową'
      },
      insertName: 'Nazwa techniczna',
      insertImageUrl: 'URL zdjęcia',
      showOnIOS: 'Pokaż na iOS',
      showOnAndroid: 'Pokaż na Androidzie',
      showOnAndroid2: {
        'dev-1': 'Pokaż na mPromocje',
        'dev-1-pl': 'Pokaż na mPromocje',
        'preprod': 'Pokaż na mPromocje',
        'preprod-pl': 'Pokaż na mPromocje',
        'pl': 'Pokaż na mPromocje',
        'ua': 'Pokaż naLove Sales Light'
      },
      insertImage: 'Naciśnij lub upuść plik aby dodać zdjęcie inserta',
      showOnWeb: 'Pokaż na Web',
      confirm: 'Utwórz',
      update: 'Zaktualizuj',
      cancel: 'Anuluj',
      select: 'Wybierz zdjęcie',
      success: 'Insert został utworzony'
    },
    rules: {
      name: 'Nazwa jest wymagana',
      image: 'Zdjęcie jest wymagane',
      existing: 'Insert o wybranej nazwie istnieje',
      geolocations: 'Każdy wiersz musi mieć format lat,lng,promień. Przekonwertuj adresy za pomocą różdżki.',
      insertNameFormat:
        'Nazwa techniczna może zawierać tylko litery, cyfry, myślniki (-) i podkreślenia (_). Spacje i inne znaki specjalne są niedozwolone.'
    },
    usage: {
      title: 'Statystyki użycia insertów',
      refresh: 'Odśwież',
      noData: 'Brak danych o użyciu insertów',
      load: 'Załaduj dane',
      totalInserts: 'Liczba używanych insertów',
      totalLeaflets: 'Liczba gazetek z insertami',
      lastUpdated: 'Ostatnia aktualizacja',
      insertName: 'Nazwa insertu',
      usageCount: 'Liczba użyć',
      actions: 'Akcje',
      details: 'Szczegóły',
      leafletDetails: 'Gazetki używające tego insertu',
      leafletId: 'ID gazetki',
      storeId: 'ID sklepu',
      storeName: 'Nazwa sklepu',
      validFrom: 'Ważna od',
      validTo: 'Ważna do',
      status: 'Status',
      view: 'Zobacz',
      used: 'Używany',
      notUsed: 'Nieużywany',
      more: 'więcej',
      showDetails: 'Pokaż szczegóły użycia',
      noLeaflets: 'Brak gazetek dla tego insertu',
      leafletNotFound: 'Gazetka nie została znaleziona'
    }
  },
  productHits: {
    boost: {
      title: 'Promuj produkt',
      promote: 'Promuj',
      cancel: 'Anuluj promowanie',
      position: 'Pozycja docelowa',
      until: 'Koniec promowania',
      startsNow: 'Promowanie rozpoczyna się natychmiast. Godziny są podane w lokalnej strefie przeglądarki.',
      validation: 'Podaj dodatnią, całkowitą pozycję oraz datę końca w przyszłości.',
      success: 'Produkt jest promowany',
      error: 'Nie udało się zmienić promocji. Spróbuj ponownie.',
      conflict: 'Produkt ma już promocję. Zlecono odświeżenie rankingu.',
      forbidden: 'Nie masz uprawnień do zarządzania promowaniem.',
      cancelConfirm: 'Anulować promowanie? Produkt wróci do pozycji wynikającej z rankingu organicznego.',
      cancelSuccess: 'Promowanie anulowane',
      notFound: 'Ta promocja już nie istnieje.',
      refreshError: 'Nie udało się odświeżyć rankingu. Ponów odczyt, aby zobaczyć aktualne pozycje.'
    },
    title: 'Hity produktowe',
    promoted: 'Promowane',
    add: 'Dodaj produkt',
    fetchData: 'Ładowanie hitów produktowych...',
    table: {
      no: '#',
      trend: 'Trend',
      product: 'Produkt',
      priceBefore: 'Przed',
      priceAfter: 'Po',
      validity: 'Obowiązuje',
      promotion: 'Promocja',
      shop: 'Sklep',
      actions: 'Akcje'
    },
    actions: {
      edit: 'Edytuj',
      delete: 'Usuń',
      refresh: 'Odśwież',
      deleteConfirmTitle: 'Usuń produkt',
      deleteConfirmMessage: 'Czy na pewno chcesz usunąć ten produkt?',
      deleteSuccess: 'Produkt został usunięty',
      deleteError: 'Nie udało się usunąć produktu'
    },
    details: {
      title: 'Podgląd produktu',
      name: 'Nazwa',
      brand: 'Marka',
      trendIndex: 'Trend indeks',
      addedToShoppingList: 'Dodania do listy zakupów',
      mainInfo: 'Informacja główna',
      position: 'Pozycja',
      priceBefore: 'Przed{currencySuffix}',
      priceAfter: 'Po{currencySuffix}',
      promotion: 'Promocja',
      validity: 'Obowiązuje',
      validFrom: 'Obowiązuje od',
      validTo: 'Obowiązuje do',
      shop: 'Sklep',
      redirectUrl: 'Przekierowanie',
      productFromLeaflet: 'Produkt z gazetki',
      editButton: 'Edytuj produkt',
      deleteButton: 'Usuń produkt',
      positionEdit: {
        confirm: 'Zatwierdź pozycję',
        cancel: 'Anuluj edycję',
        success: 'Pozycja została zaktualizowana',
        error: 'Nie udało się zaktualizować pozycji',
        validationError: 'Pozycja musi być liczbą całkowitą większą lub równą 1'
      }
    },
    form: {
      title: 'Dodaj produkt',
      editTitle: 'Edytuj produkt',
      label: 'Nazwa',
      brand: 'Marka',
      tiValue: 'Trend indeks',
      crossedPrice: 'Cena przed',
      currentPrice: 'Cena po',
      mainInfo: 'Informacja główna',
      discount: 'Promocja',
      validFrom: 'Obowiązuje od',
      validTo: 'Obowiązuje do',
      storeName: 'Sklep',
      redirectUrl: 'Przekierowanie',
      isPromotedDescription: 'Oferta promowana',
      isPromotedDetails: 'Czy produkt ma mieć oznaczenie "Sponsorowane"',

      uploadProduct: 'Naciśnij lub upuść plik aby dodać zdjęcie produktu',
      uploadProductReplace: 'Naciśnij lub upuść plik aby zastąpić zdjęcie produktu',
      uploadStoreLogo: 'Naciśnij lub upuść plik aby dodać logo sklepu',
      uploadStoreLogoReplace: 'Naciśnij lub upuść plik aby zastąpić logo sklepu',
      productImagePreviewAlt: 'Podgląd zdjęcia produktu',
      storeLogoPreviewAlt: 'Podgląd logo sklepu',
      createSuccess: 'Produkt został dodany',
      createError: 'Nie udało się dodać produktu',
      editSuccess: 'Produkt został zaktualizowany',
      editError: 'Nie udało się zaktualizować produktu',
      rules: {
        label: 'Nazwa jest wymagana',
        tiValue: 'Trend indeks jest wymagany',
        crossedPriceRequiresCurrentPrice: 'Cena przekreślona wymaga ceny promocyjnej',
        priceOrMainInfo: 'Podaj cenę promocyjną lub informację główną',
        mainInfoMaxLength: 'Informacja główna może mieć maksymalnie {max} znaków',
        validFrom: 'Data od jest wymagana',
        validTo: 'Data do jest wymagana',
        productImage: 'Zdjęcie produktu jest wymagane',
        storeName: 'Nazwa sklepu jest wymagana'
      }
    }
  },
  logs: {
    pickFile: 'Wybierz plik',
    downloadFile: 'Pobierz logi'
  },
  xmls: {
    pickDevice: 'Wybierz typ urządzenia'
  },
  productCategories: {
    loading: 'Ładowanie kategorii produktów...',
    loadError: 'Nie udało się pobrać kategorii produktów.',
    code: 'Kod',
    name: 'Nazwa',
    sortOrder: 'Kolejność',
    status: 'Status',
    active: 'Aktywna',
    inactive: 'Nieaktywna',
    updatedAt: 'Ostatnia zmiana',
    actions: 'Akcje',
    activate: 'Aktywuj',
    deactivate: 'Dezaktywuj',
    activated: 'Kategoria aktywowana.',
    deactivated: 'Kategoria dezaktywowana.',
    addCategory: 'Dodaj kategorię',
    addSubcategory: 'Dodaj podkategorię',
    edit: 'Edytuj',
    form: {
      createTitle: 'Dodaj kategorię produktu',
      codeImmutable: 'Kodu nie można zmienić po utworzeniu kategorii.',
      parent: 'Rodzic',
      parentPlaceholder: 'Brak (kategoria główna)',
      sortOrderHint: 'Zostaw puste, aby umieścić na końcu.',
      cancel: 'Anuluj',
      create: 'Dodaj',
      createSuccess: 'Dodano kategorię produktu.',
      editTitle: 'Edytuj kategorię produktu',
      save: 'Zapisz',
      editSuccess: 'Zapisano kategorię produktu.',
      renameConfirm: {
        title: 'Zmienić nazwę kategorii?',
        message:
          'Oferty i polityki przypisane do „{from}” stracą tę kategorię, bo wskazują kategorie po nazwie. Zmienić nazwę na „{to}”?',
        confirm: 'Zmień nazwę'
      },
      errors: {
        code: {
          required: 'Podaj kod.',
          tooLong: 'Kod może mieć maksymalnie 200 znaków.',
          invalidFormat: 'Użyj małych liter, cyfr, „.”, „_” i „-”, zaczynając od litery lub cyfry.'
        },
        name: {
          required: 'Podaj nazwę.',
          tooLong: 'Nazwa może mieć maksymalnie 255 znaków.'
        }
      }
    },
    nameStatus: {
      inactive: 'nieaktywna',
      unknown: 'nieznana'
    },
    errors: {
      accessDenied: 'Brak uprawnień do kategorii produktów.',
      hasChildren: 'Kategoria ma aktywne podkategorie. Najpierw dezaktywuj jej podkategorie.',
      codeAlreadyExists: 'Kategoria o tym kodzie już istnieje.',
      nameAlreadyExists: 'Kategoria o tej nazwie już istnieje pod tym rodzicem.',
      invalidCode: 'Nieprawidłowy kod.',
      parentNotFound: 'Kategoria nadrzędna już nie istnieje. Odśwież stronę i spróbuj ponownie.',
      cycle: 'Nie można przenieść kategorii pod nią samą ani pod jej podkategorię.',
      notFound: 'Kategoria już nie istnieje. Odśwież stronę i spróbuj ponownie.',
      unknown: 'Nieoczekiwany błąd. Spróbuj ponownie później.'
    }
  },
  categories: {
    fetchData: 'Ładowanie kategorii...',
    logo: 'Logo',
    id: 'ID',
    name: 'Nazwa',
    categoryWebId: 'Nazwa Id',
    update: {
      title: 'Edytuj kategorie',
      button: 'Edytuj',
      success: 'Kategoria została zaktualizowana'
    },
    create: {
      title: 'Utwórz kategorie',
      button: 'Dodaj kategorie',
      success: 'Kategoria została utworzona'
    },
    rules: {
      name: 'Nazwa kategorii jest wymagana',
      categoryWebId: 'Nazwa Id jest wymagana'
    },
    logoUpload: 'Naciśnij lub upuść plik aby dodać logo kategorii',
    updateConfirm: 'Zapisz',
    createConfirm: 'Dodaj',
    cancel: 'Anuluj',
    actions: 'Akcje',
    remove: {
      button: 'Usuń',
      confirm: 'Czy na pewno chcesz usunąć tą kategorię?',
      success: 'Kateogria została usunięta'
    }
  },
  archives: {
    inserts: {
      restore: 'Przywróć',
      restoreConfirm: 'Czy na pewno chcesz przywrócić ten insert?',
      restoreSuccess: 'Insert został przywrócony',
      restoreError: 'Błąd podczas przywracania inserta',
      clearSearch: 'Wyczyść wyszukiwanie',
      noData: 'Brak insertów',
      noDataFound: 'Brak insertów znalezionych po tej frazie wyszukiwania'
    },
    selectType: 'Wybierz typ archiw jakie chcesz zobaczyc',
    placeholder: 'Wybierz',
    navButtons: {
      leaflets: 'Gazetki',
      shops: 'Sklepy',
      notifications: 'Notyfikacje',
      leafletDetails: 'Szczegóły gazetki'
    },
    leaflets: {
      restore: 'Przywróć',
      viewDetails: 'Zobacz szczegóły',
      leafletsCount: 'gazetek',
      pickDate: 'Podaj datę',
      moreActions: 'Więcej akcji',
      expandFilters: 'Rozwiń filtry',
      collapseFilters: 'Zwiń filtry',
      filters: {
        title: 'Filtry',
        storeName: 'Nazwa sklepu:',
        subtitle: 'Podtytuł:',
        validDates: 'Daty ważności:',
        searchButton: 'Szukaj',
        clearButton: 'Wyczyść',
        validFrom: 'Ważna od:',
        validTo: 'Ważna do:',
        sortBy: 'Sortuj po:',
        noData: 'Brak danych do wyświetlenia',
        pressSearchButton: "Kliknij 'Szukaj' aby wyświetlić dane"
      },
      sortOptions: {
        id: 'Id sklepu',
        name: 'Nazwie sklepu',
        category: 'Kategorii',
        storeWebId: 'Store web id',
        logoUrl: 'Logo URL',
        showAnyway: 'Show anyway',
        storeAtFirst: 'Store at first',
        ascend: 'Rosnąco',
        descend: 'Malejąco',
        order: 'Kolejność'
      },
      selectOptions: {
        true: 'Tak',
        false: 'Nie'
      }
    },
    notifications: {
      title: 'Notyfikacje',
      filters: {
        title: 'Filtry i sortowanie'
      },
      tableLabels: {
        device: 'Urządzenie',
        notificationId: 'Id notyfikacji',
        responseCode: 'Kod odpowiedzi',
        sentAt: 'Data wysłki',
        stores: 'Sklepy',
        channel: 'Kanał',
        details: 'Detale'
      },
      sortOptions: {
        device: 'Urządzeniach',
        id: 'ID',
        notificationId: 'Id notyfikacji',
        responseCode: 'Kodzie odpowiedzi',
        sentAt: 'Dacie wysyłki',
        stores: 'Sklepach'
      }
    },
    leafletDetails: {
      additionalInfo: 'Dodatkowe informacje: ',
      naturalId: 'Natural ID: ',
      seoId: 'SEO ID: ',
      status: 'Status: ',
      platforms: 'Platformy publikacji: ',
      validFrom: 'Ważna od ',
      validTo: ' do ',
      publishDate: 'Data publikacji: ',
      createdAt: 'Data stworzenia: ',
      numberOfPages: 'Liczba stron: ',
      showAdInserts: 'Pokaż inserty: ',
      zipCode: 'Kod pocztowy: ',
      longURL: 'URL: ',
      thumbnailTrackingUrl: 'Zliczający miniaturki URL: ',
      redirectURL: 'Przekierowanie URL: ',
      searchLabel: 'Wpisz Natural ID gazetki',
      searchPlacecholder: 'Natural ID gazetki',
      closeCard: 'Zamknij kartę',
      createdBy: 'Opoblikowana przez: ',
      activateReadyStatusAt: 'Data odświeżenia: ',
      refreshedBy: 'Odświeżona przez: '
    },
    leafletUpdateHistory: {
      title: 'Historia edycji',
      leafletHistoryTab: 'Historia gazetki',
      pageDetailsHistoryTab: 'Historia insertów',
      redirectsHistoryTab: 'Historia przekierowań',
      description: 'Opis',
      actionType: 'Typ akcji',
      field: 'Pole',
      oldValue: 'Poprzednia wartość',
      newValue: 'Nowa wartość',
      pageNumber: 'Nr pozycji',
      visibleAt: 'Widoczny na',
      insertName: 'Nazwa techniczna',
      modifiedBy: 'Edytowane przez',
      modifiedAt: 'Data edycji',
      added: 'Dodano',
      deleted: 'Usunięto',
      redirects: {
        description: 'Opis',
        pageNumber: 'Numer strony',
        redirectURL: 'Przekierowanie URL',
        longURL: 'Zliczający URL'
      },
      android: 'Android',
      ios: 'IOS',
      longUrlVisibleAt: 'Zliczający URL dla',
      redirectUrl: 'Przekierowanie URL',
      longUrl: 'Zliczający URL',
      previousValue: 'Poprzednia wartość: '
    },
    shops: {
      noArchivedShops: 'Brak zarchiwizowanych sklepów',
      archived: 'Zarchiwizowany'
    },
    restore: {
      title: 'Potwierdź przywrócenie',
      button: 'Przywróć',
      confirm: 'Czy na pewno chcesz przywrócić ten sklep?',
      success: 'Sklep został przywrócony.'
    }
  },
  showHttpWarning: 'Nowe wersje iOS i Androida nie mogą otwierać linków bez SSL!',
  cooksAndRecipes: {
    recipeTable: {
      title: 'Tytuł',
      type: 'Typ',
      visibleAt: 'Widoczny na',
      status: {
        label: 'Status'
      },
      actions: {
        label: 'Akcje',
        edit: 'Edytuj',
        preview: 'Podgląd przepisu',
        delete: 'Usuń'
      }
    },
    addCookDialog: {
      title: 'Dodaj nowego kucharza',
      availableEditors: 'Dostępni edytorzy',
      assignedEditors: 'Przypisani edytorzy',
      labels: {
        name: 'Nazwa kucharza',
        id: 'Nazwa id',
        logoUpload: 'Naciśnij lub upuść plik aby dodać logo kucharza'
      },
      success: {
        create: 'Kucharz {name} stworzony pomyślnie.',
        update: 'Kucharz {name} pomyślnie zaktualizowany.'
      },
      placeholders: {
        name: 'Podaj nazwę kucharza'
      },
      rules: {
        requiredName: 'Nazwa kucharza jest wymagana',
        required: 'To pole jest wymagane',
        seoIdRule: 'Nazwa Id może się składać tylko z małych liter, cyfr oraz znaku "-"',
        cookNameTaken: 'Isnieje już kucharz o takiej nazwie.'
      },
      statusList: {
        INACTIVE: 'Nieaktywny',
        READY_FOR_ACTIVATION: 'Gotowy na aktywację',
        READY_FOR_DISACTIVATION: 'Gotowy na dezaktywację',
        ACTIVE: 'Aktywny'
      },
      footerButtons: {
        cancel: 'Anuluj',
        create: 'Dodaj kucharza',
        update: 'Zapisz zmiany'
      }
    },
    addRecipeDialog: {
      recipePages: 'Strony przepisu',
      footerButtons: {
        create: 'Dodaj przepis'
      },
      addStep: 'Dodaj krok',
      rules: {
        required: 'To pole jest obowiązkowe',
        onlyNumbers: 'Proszę podać popranwą wartość',
        invalidShoppingListUrl:
          'Link do listy zakupowej jest niepoprawny. Link powinien pasować do wzoru: \nhttps://mojagazetka.com/lista/ID-listy-zakupowej',
        isFromRecipe: 'Lista z przepisu (isFromRecipe: true)'
      },
      success: {
        create: 'Przepis stworzony pomyślnie.',
        update: 'Przepis zaktualizowany pomyślnie.'
      },
      title: 'Dodaj nowy przepis',
      editTitle: 'Edytuj przepis',
      labels: {
        logoUpload: 'Naciśnij lub upuść plik aby dodać okładkę przepisu',
        stepImageUpload: 'Naciśnij lub upuść plik aby dodać zdjęcie dla kroku',
        recipeCreatedWith: 'Przepis stworzony we współpracy z siecią',
        leafletId: 'ID gazetki',
        seoId: 'ID',
        publishDate: 'Publikacja',
        status: 'Status',
        title: 'Tytuł',
        preparationTime: 'Czas przygotowania',
        complexity: 'Trudność wykonania',
        tags: 'Tagi',
        longUrl: 'Zliczający URL',
        shoppingListUrl: 'Lista zakupów URL',
        shoppingList: 'Lista zakupów',
        visibleAt: 'Widoczny na',
        numberOfServings: 'Ilość porcji'
      },
      placeholders: {
        shoppingListUrl: 'Dodaj link do listy zakupów, którą stworzyłeś na telefonie',
        shoppingList: 'Tutaj pojawią się składniki zawarte w liście zakupowej',
        loading: 'Ładowanie listy zakupów...',
        leafletId: 'Wprowadź UUID gazetki',
        missingShoppingListProducts: 'Lista zakupowa jest pusta lub ma niepoprawne ID',
        complexity: 'Wybierz poziom trudności',
        tags: 'Wprowadź tagi oddzielając je przecinkiem',
        title: 'Wprowadź tytuł przepisu',
        preparationTime: 'Podaj czas przygotowania w minutach',
        cooperatedWith: 'Wybierz sklep',
        stepName: 'Nazwa kroku',
        description: 'Opis',
        extraDescription: 'Opis dodatkowy'
      },
      complexity: {
        easy: 'Łatwa',
        medium: 'Srednia',
        hard: 'Trudna'
      }
    },
    recipes: {
      publish: {
        button: 'Opublikuj przepisy',
        confirm: 'Czy na pewno chcesz opublikować przepisy?',
        success: 'Pomyślnie opublikowano przepisy.'
      },
      showAll: 'Rozwiń wszystkie przepisy',
      hideAll: 'Zwiń wszystkie przepisy',
      delete: {
        confirm: 'Czy na pewno chcesz usunąć ten przepis?',
        success: 'Przepis został usunięty.'
      }
    },
    cooks: {
      addRecipe: 'Dodaj przepis',
      editCook: 'Edytuj kucharza',
      deleteCook: 'Usuń kucharza',
      addCook: 'Dodaj kucharza',
      delete: {
        confirm: 'Czy na pewno chcesz usunąć kucharza: {cook}?',
        success: 'Kucharz {cook} usunięty pomyślnie.'
      },
      collapseRecipes: 'Zwiń przepisy',
      expandRecipes: 'Rozwiń przepisy',
      fetching: 'Ładowanie kucharzy...',
      noCooks: 'Brak kucharzy do wyświetlenia!',
      noCooksDetails: 'Dodaj pierwszego kucharza aby można było wyświetlić jego szczegóły.'
    },
    recipePreview: {
      title: 'Podgląd przepisu',
      noImage: 'Brak zdjęcia',
      preparationMinutes: 'Minut',
      portionFor: 'Dla {number} osób',
      complexity: {
        easy: 'Łatwe',
        medium: 'Średnie',
        hard: 'Trudne'
      },
      summarizeHeader: 'Gotowe? Smacznego!',
      summarizeText: 'Dodaj potrawę do Ugotowanych, aby zawsze mieć ją w zasięgu ręki!'
    }
  },
  scrapper: {
    tabs: {
      zipTabName: 'Paczka zip',
      pdfTabName: 'Generowanie pliku pdf'
    },
    pdf: {
      urlInputPlaceholder: 'Podaj URL do .pdf',
      downloadButtonLabel: 'Wygeneruj link do .pdf',
      copyLink: 'Skopiuj link',
      linkToFile: 'Link do pliku:',
      copySuccess: 'Skopiowano link do schowka',
      copyError: 'Błąd podczas kopiowania linku'
    },
    zip: {
      urlInputPlaceholder: 'URL gazetki',
      urlInputPrefixPlaceholder: 'Prefix gazetki',
      downloadButtonLabel: 'Pobierz plik',
      ifDownloadDidntStart: 'Jeżeli pobieranie nie zaczęło się automatycznie',
      clickHere: 'kliknij tutaj'
    }
  },
  reels: {
    urlCopiedToClipboard: {
      success: 'Link skopiowany',
      error: 'Nie udało się skopiować linku'
    },
    header: {
      title: 'Kanały ({reelsChannelsCount})',
      buttons: {
        addChannel: 'Dodaj nowy kanał'
      },
      showExpiredReels: 'Pokaż wygasłe reelsy'
    },
    addChannel: {
      title: 'Dodaj nowy kanał',
      form: {
        logo: 'Kliknij tutaj albo upuść plik aby dodać logo',
        naturalId: 'Natural ID',
        name: 'Nazwa',
        description: 'Opis',
        positionIndex: 'Stała pozycja',
        positionIndexPlaceholder: 'Pozostaw puste dla domyślnego sortowania',
        clearPosition: 'Wyczyść pozycję',
        tracking: {
          title: 'Trackowanie',
          trackingUrlView: 'Wyświetlenie',
          trackingUrlViewPlaceholder: 'Wprowadź URL trackujący dla wyświetleń',
          trackingUrlClick: 'Kliknięcie',
          trackingUrlClickPlaceholder: 'Wprowadź URL trackujący dla kliknięć'
        },
        autoCreateReels: {
          description: 'Generuj automatyczne reels',
          details: 'Gdy zaznaczone, nowe reelsy będą generowane automatycznie na podstawie dodawanych gazetek'
        },
        buttons: {
          create: 'Dodaj kanał',
          cancel: 'Anuluj'
        },
        validations: {
          naturalId: 'Natural ID jest wymagane',
          name: 'Nazwa kanału jest wymagana',
          positionIndex: 'Pozycja musi być nieujemną liczbą całkowitą',
          trackingUrl: 'URL trackujący musi zaczynać się od http:// lub https://',
          trackingUrlLength: 'URL trackujący może mieć maksymalnie 255 znaków'
        }
      },
      success: 'Kanał został dodany',
      errors: {
        positionIndexDuplicated: 'Kanał z tą pozycją już istnieje dla tego kraju',
        positionIndexNegative: 'Indeks pozycji nie może być ujemny',
        generic: 'Podczas zapisywania kanału wystąpił błąd'
      }
    },
    editChannel: {
      title: 'Edytuj kanał {channelName}',
      form: {
        buttons: {
          update: 'Zaktualizuj'
        }
      },
      success: 'Kanał został zaktualizowany'
    },
    addReel: {
      title: 'Dodaj nową rolkę',
      form: {
        logo: 'Naciśnij lub upuść aby dodać plik',
        mediaURL: 'Media URL',
        naturalId: 'Natural ID',
        shortDescription: 'Opis',
        ctaButtonText: {
          label: 'CTA',
          placeholder: 'Dodaj treść przycisku'
        },
        visibilityTime: {
          label: 'Długość',
          suffix: 'sekund | sekunda | sekundy | sekund'
        },
        status: {
          label: 'Status',
          options: {
            draft: 'Draft',
            deactivated: 'Nieaktywny',
            published: 'Opublikowany'
          }
        },
        visibilityStartDate: {
          label: 'Od',
          placeholder: 'Wybierz datę i godzinę'
        },
        visibilityEndDate: {
          label: 'Do',
          placeholder: 'Wybierz datę i godzinę'
        },
        publishDate: {
          label: 'Publikacja',
          placeholder: 'Wybierz datę i godzinę'
        },
        mediaType: {
          label: 'Typ'
        },
        internalNote: {
          label: 'Notatka',
          placeholder: 'Dodaj notatkę techniczną'
        },
        showOn: 'Pokaż na',
        tracking: {
          title: 'Trackowanie',
          impressionsTracking: 'Wyświetlenia',
          clicksTracking: 'Kliknięcia'
        },
        actionType: {
          label: 'Typ akcji',
          leafletRedirect: {
            label: 'Przekierowanie do gazetki',
            insertNumber: 'Numer insertu',
            standardPageNumber: 'Numer strony',
            leafletId: 'ID gazetki',
            leafletIdPlaceholder: 'Szukaj po ID gazetki, nazwie sklepu lub tytule...'
          },
          externalRedirect: {
            label: 'Przekierowanie zewnętrzne',
            url: 'URL'
          },
          shoppingListAdd: {
            label: 'Lista zakupowa',
            productName: 'Nazwa produktu'
          }
        },
        buttons: {
          create: 'Zapisz i opublikuj',
          createDraft: 'Zapisz szkic',
          cancel: 'Anuluj'
        },
        validations: {
          naturalId: 'Natural ID jest wymagane',
          file: 'Plik z rolką jest wymagany',
          visibilityTime: 'Długość trwania rolki jest wymagana',
          status: 'Status rolki jest wymagany',
          visibilityStartDate: 'Data początku wyświetlania rolki jest wymagana',
          visibilityEndDate: {
            required: 'Data końca wyświetlania rolki jest wymagana',
            dateFromThePast: 'Data końca jest z przeszłości',
            datePreviousThanStartDate: 'Data końca wyświetlania rolki jest wcześniej niż data początku'
          },
          publishDate: 'Data publikacji jest wymagana',
          mediaType: 'Typ rolki jest wymagany',
          action: {
            leafletId: 'ID gazetki jest wymagany',
            leafletIdFormat:
              'ID gazetki musi mieć format: nazwaSklepu-dd-mm-yy-dd-mm-yy-abcde (np. biedronka-16-07-25-22-07-25-nckyx)',
            standardPageNumber: 'Numer strony jest wymagany',
            url: 'Adres przekierowania jest wymagany',
            productName: 'Nazwa produktu jest wymagana'
          }
        }
      },
      success: 'Rolka została dodana'
    },
    editReel: {
      title: 'Edytuj rolkę',
      form: {
        buttons: {
          update: 'Zaktualizuj',
          updateDraft: 'Zaktualizuj szkic'
        }
      },
      success: 'Rolka została zaktualizowana'
    },
    publishReel: {
      confirm: 'Czy na pewno chcesz opublikować rolkę?',
      success: 'Rolka została opublikowana',
      button: 'Opublikuj rolkę'
    },
    deactivateReel: {
      confirm: 'Czy na pewno chcesz dezaktywować rolkę?',
      success: 'Rolka została dezaktywowana',
      button: 'Dezaktywuj rolkę'
    },
    removeReel: {
      confirm: 'Czy na pewno chcesz usunąć rolkę?',
      success: 'Rolka została usunięta',
      button: 'Usuń rolkę'
    },
    channel: {
      empty: 'Brak kanałów do wyświetlenia',
      cardHeader: {
        imageAlt: 'Logo kanału',
        active: 'Aktywne: {activeReelsCount}',
        archived: 'Archiwum: {archivedReelsCount}',
        addReels: 'Dodaj Reel',
        moreOptions: {
          edit: 'Edytuj',
          remove: 'Usuń kanał'
        }
      },
      noReels: 'Brak reelsów do wyświetlenia.',
      delete: {
        confirm: 'Czy na pewno chcesz usunąć kanał {channelName}?',
        success: 'Kanał został usunięty',
        button: 'Usuń'
      },
      positionFixed: 'Pozycja: {position}'
    },
    basicReelData: {
      id: 'ID',
      naturalId: 'Natural ID',
      description: 'Opis',
      visibilityTime: 'Czas trwania',
      type: 'Typ',
      cta: 'CTA',
      mediaType: 'Typ medium',
      validFor: 'Ważny',
      expired: 'Ten reels wygasł',
      moreOptions: {
        edit: 'Edytuj',
        publish: 'Opublkuj',
        deactivate: 'Dezaktywuj'
      }
    },
    advancedReelData: {
      hideDetails: 'Ukryj szczegóły',
      showDetails: 'Pokaż szczegóły',
      createdAt: 'Data utworzenia',
      interactionMadeBy: '{date} przez {user}',
      lastEditedAt: 'Ostatnia edycja',
      visibleOn: 'Pokaż na',
      trackingUrlDisplayCount: 'Wyświetlenia (tracking link)',
      trackingUrlClickCount: 'Kliknięcia (tracking link)',
      note: 'Notatka',
      leafletId: 'ID Gazetki',
      standardPageNumber: 'Numer strony',
      insertNumber: 'Numer insertu',
      link: 'Link',
      productName: 'Nazwa produktu',
      placeholders: {
        noShortDescription: '/brak opisu/',
        noCtaButton: '/brak treści/',
        noAvailablePlatforms: '/brak platform/',
        noLink: '/brak linku/',
        noNote: '/brak notatki/',
        noEdit: '/brak edycji/'
      }
    }
  },
  loyaltyCards: {
    addCard: 'Dodaj kartę',
    editCard: 'Edytuj kartę',
    deleteCard: 'Usuń kartę',
    cardId: 'ID karty',
    cardName: 'Nazwa karty',
    store: 'Sklep',
    storeId: 'ID sklepu',
    legacyId: 'ID legacy',
    color: 'Kolor',
    cardImages: 'Obrazy karty',
    cardImage: 'Obraz karty',
    uploadImage: 'Prześlij obraz',
    uploadImageHint: 'Przeciągnij i upuść lub kliknij, aby przesłać',
    changeImage: 'Zmień',
    removeImage: 'Usuń',
    isPopular: 'Popularna',
    popular: 'Popularna',
    edit: 'Edytuj',
    noCards: 'Nie znaleziono kart lojalnościowych',
    selectCountry: 'Wybierz kraj',
    createSuccess: 'Karta lojalnościowa została utworzona pomyślnie',
    updateSuccess: 'Karta lojalnościowa została zaktualizowana pomyślnie',
    deleteSuccess: 'Karta lojalnościowa została usunięta pomyślnie',
    placeholders: {
      cardId: 'Wprowadź ID karty (tylko małe litery, cyfry i myślniki)',
      cardName: 'Wprowadź nazwę karty',
      selectStore: 'Wybierz sklep',
      selectColor: 'Wybierz kolor'
    },
    validation: {
      cardIdRequired: 'ID karty jest wymagane',
      cardIdMinLength: 'ID karty musi mieć co najmniej 2 znaki',
      cardIdMaxLength: 'ID karty może mieć maksymalnie 50 znaków',
      cardIdInvalidFormat: 'ID karty może zawierać tylko małe litery, cyfry i myślniki',
      cardNameRequired: 'Nazwa karty jest wymagana',
      cardNameMinLength: 'Nazwa karty musi mieć co najmniej 2 znaki',
      cardNameMaxLength: 'Nazwa karty może mieć maksymalnie 50 znaków',
      colorRequired: 'Wybór koloru jest wymagany',
      imageRequired: 'Obraz karty jest wymagany',
      imageInvalidType: 'Proszę przesłać prawidłowy plik obrazu'
    },
    deleteConfirm: 'Czy na pewno chcesz usunąć tę kartę lojalnościową?',
    errorFetching: 'Błąd podczas pobierania kart lojalnościowych',
    errorCreating: 'Błąd podczas tworzenia karty lojalnościowej',
    errorUpdating: 'Błąd podczas aktualizacji karty lojalnościowej',
    errorDeleting: 'Błąd podczas usuwania karty lojalnościowej'
  },
  components: {
    leafletSeoIdInput: {
      placeholder: 'Szukaj po seoId gazetki, nazwie sklepu lub tytule...'
    }
  },
  slider: {
    title: 'Slider',
    addSlide: 'Dodaj nowy slide',
    editSlide: 'Edytuj slide',
    deleteSlide: 'Usuń slide',
    activeCount: 'Aktywne: {count}',
    inactiveCount: 'Nieaktywne: {count}',
    noSlides: 'Brak slajdów do wyświetlenia',
    errorFetching: 'Błąd podczas ładowania slajdów',
    errorCreating: 'Błąd podczas tworzenia slajdu',
    errorUpdating: 'Błąd podczas aktualizacji slajdu',
    errorDeleting: 'Błąd podczas usuwania slajdu',
    errorReordering: 'Błąd podczas zmiany kolejności slajdu',
    createSuccess: 'Slajd utworzony pomyślnie',
    updateSuccess: 'Slajd zaktualizowany pomyślnie',
    deleteSuccess: 'Slajd usunięty pomyślnie',
    deleteConfirm: 'Czy na pewno chcesz usunąć ten slajd?',
    deleteDialog: {
      title: 'Usuń slajd',
      message: 'Co chcesz zrobić z tym slajdem?',
      delete: 'Usuń na stałe',
      markAsDraft: 'Oznacz jako szkic',
      cancel: 'Anuluj'
    },
    markAsDraftSuccess: 'Slajd oznaczony jako szkic',
    form: {
      title: 'Dodaj slide',
      editTitle: 'Edytuj slide',
      slideType: {
        label: 'Typ slajdu',
        placeholder: 'Wybierz typ slajdu',
        image: 'Obraz',
        gif: 'GIF'
      },
      uploadImage: 'Naciśnij lub upuść plik aby dodać',
      uploadGif: 'Naciśnij lub upuść plik GIF aby dodać',
      description: {
        label: 'Opis',
        placeholder: 'Wprowadź opis slajdu'
      },
      name: {
        label: 'Tytuł',
        placeholder: 'Wprowadź tytuł slajdu'
      },
      redirect: {
        label: 'URL przekierowania',
        placeholder: 'Wprowadź URL przekierowania'
      },
      linkType: {
        label: 'Typ linkowania',
        external: 'URL zewnętrzny',
        leaflet: 'Gazetka'
      },
      leafletRedirect: {
        leafletId: 'ID gazetki',
        leafletIdPlaceholder: 'Szukaj po ID gazetki, nazwie sklepu lub tytule...',
        standardPageNumber: 'Numer strony',
        insertNumber: 'Numer insertu'
      },
      position: {
        label: 'Pozycja',
        placeholder: 'Wprowadź pozycję'
      },
      status: {
        label: 'Status',
        placeholder: 'Wybierz status'
      },
      validityPeriod: 'Okres ważności',
      validFrom: {
        label: 'Od',
        placeholder: 'Wybierz datę i godzinę'
      },
      validTo: {
        label: 'Do',
        placeholder: 'Wybierz datę i godzinę'
      },
      publishedAt: {
        label: 'Publikacja',
        placeholder: 'Wybierz datę i godzinę'
      },
      note: {
        label: 'Notatka',
        placeholder: 'Dodaj notatkę'
      },
      showOn: 'Pokaż na:',
      tracking: {
        title: 'Trackowanie',
        views: 'Wyświetlenia',
        clicks: 'Kliknięcia',
        trackingUrlView: {
          label: 'Wyświetlenie',
          placeholder: 'Wprowadź URL trackujący dla wyświetleń'
        },
        trackingUrlClick: {
          label: 'Kliknięcie',
          placeholder: 'Wprowadź URL trackujący dla kliknięć'
        }
      },
      buttons: {
        cancel: 'Anuluj',
        save: 'Zapisz'
      },
      uploadLimit: 'Można przesłać tylko jeden plik'
    },
    rules: {
      imageRequired: 'Obraz jest wymagany',
      gifRequired: 'Plik GIF jest wymagany',
      nameRequired: 'Tytuł jest wymagany',
      statusRequired: 'Status jest wymagany',
      validFromRequired: 'Data rozpoczęcia jest wymagana',
      redirectUrlInvalid: 'Nieprawidłowy format URL',
      leafletIdRequired: 'ID gazetki jest wymagany',
      leafletIdInvalid:
        'ID gazetki musi mieć format: nazwaSklepu-dd-mm-yy-dd-mm-yy-abcde (np. biedronka-16-07-25-22-07-25-nckyx)',
      standardPageNumberRequired: 'Numer strony jest wymagany',
      leafletPageTargetRequired: 'Ustaw numer strony albo numer insertu',
      positionInvalid: 'Pozycja musi być liczbą większą lub równą 0'
    },
    table: {
      name: 'Nazwa',
      redirect: 'Przekierowanie',
      trackingUrl: 'Zliczający URL',
      added: 'Dodany',
      updated: 'Zaktualizowany',
      position: 'Pozycja',
      validFrom: 'Ważny od',
      validTo: 'Ważny do',
      visibility: 'Widoczność',
      status: 'Status',
      actions: 'Akcje',
      noData: 'Brak danych',
      pageNumber: 'strona',
      insertNumber: 'insert',
      none: 'brak'
    },
    status: {
      active: 'Aktywny',
      inactive: 'Nieaktywny',
      draft: 'Szkic'
    },
    platforms: {
      web: 'Web',
      ios: 'iOS',
      android: 'Android',
      mpromocje: 'mPromocje'
    },
    aspectRatio: {
      '16x9': '16:9',
      '4x3': '4:3',
      '1x1': '1:1'
    },
    filters: {
      title: 'Filtry',
      clear: 'Wyczyść',
      clearAll: 'Wyczyść wszystkie filtry',
      apply: 'Zastosuj',
      activeFilters: 'Aktywne filtry',
      showActive: 'Pokaż aktywne slidery',
      showVisibleNow: 'Widoczne u klientów',
      visibleNow: 'Widoczne u klientów',
      platform: {
        title: 'Filtruj według platformy'
      },
      status: {
        title: 'Filtruj według statusu',
        all: 'Wszystkie',
        active: 'Aktywne',
        draft: 'Szkice',
        expired: 'Wygasłe'
      }
    },
    sorting: {
      sortBy: 'Sortuj według',
      ascending: 'Rosnąco',
      descending: 'Malejąco'
    }
  },
  tradeDays: {
    title: 'Dni Handlowe',
    status: 'Status',
    statusList: {
      STORES_CLOSED: 'Sklepy zamknięte',
      STORES_OPENED: 'Sklepy otwarte',
      CUSTOM: 'Niestandardowy',
      NOT_APPLICABLE: 'Nie dotyczy'
    },
    months: {
      0: 'Styczeń',
      1: 'Luty',
      2: 'Marzec',
      3: 'Kwiecień',
      4: 'Maj',
      5: 'Czerwiec',
      6: 'Lipiec',
      7: 'Sierpień',
      8: 'Wrzesień',
      9: 'Październik',
      10: 'Listopad',
      11: 'Grudzień'
    },
    weekDays: {
      Mon: 'Pon',
      Tue: 'Wt',
      Wed: 'Śr',
      Thu: 'Czw',
      Fri: 'Pt',
      Sat: 'Sob',
      Sun: 'Ndz'
    },
    modal: {
      createTitle: 'Utwórz dzień handlowy',
      editTitle: 'Edytuj dzień handlowy'
    },
    form: {
      date: 'Data',
      selectDate: 'Wybierz datę',
      status: 'Status',
      localizedFields: 'Pola lokalizowane',
      title: 'Tytuł',
      titlePlaceholder: 'Wprowadź tytuł',
      tip: 'Wskazówka',
      tipPlaceholder: 'Wprowadź wskazówkę',
      customDescription: 'Opis niestandardowy',
      customDescriptionPlaceholder: 'Wprowadź opis niestandardowy',
      copyFromDay: 'Kopiuj z innego dnia',
      copyFromDayDescription: 'Skopiuj wartości z istniejącego dnia handlowego, aby wypełnić puste pola'
    },
    copyDialog: {
      title: 'Kopiuj z innego dnia',
      selectYear: 'Wybierz rok',
      selectDate: 'Wybierz datę do skopiowania',
      preview: 'Podgląd',
      noDataForYear: 'Brak dni handlowych dla {year}',
      noDaysAvailable: 'Brak dostępnych dni handlowych do skopiowania',
      copyButton: 'Kopiuj do formularza',
      cancel: 'Anuluj',
      emptyField: 'Nie ustawiono',
      previewDate: 'Data',
      previewStatus: 'Status',
      previewTitles: 'Tytuły',
      previewTips: 'Wskazówki',
      previewDescriptions: 'Opisy'
    },
    validation: {
      dayDateRequired: 'Data jest wymagana',
      dayStatusRequired: 'Status jest wymagany',
      dayStatusInvalid: 'Nieprawidłowa wartość statusu',
      maxLength: 'Maksymalna długość to {max} znaków',
      fieldMaxLength: '{field} przekracza maksymalną długość {max} znaków'
    },
    messages: {
      createSuccess: 'Dzień handlowy został utworzony',
      updateSuccess: 'Dzień handlowy został zaktualizowany',
      deleteSuccess: 'Dzień handlowy został usunięty',
      copySuccess: 'Wartości skopiowane z {date}',
      copyOnlyEmptyFields: 'Wypełniono tylko puste pola'
    },
    errors: {
      fetchFailed: 'Nie udało się załadować dni handlowych',
      createFailed: 'Nie udało się utworzyć dnia handlowego',
      updateFailed: 'Nie udało się zaktualizować dnia handlowego',
      deleteFailed: 'Nie udało się usunąć dnia handlowego'
    },
    deleteConfirm: {
      title: 'Usuń dzień handlowy',
      message: 'Czy na pewno chcesz usunąć ten dzień handlowy? Tej operacji nie można cofnąć.'
    },
    bulkUpdate: {
      buttonLabel: 'Aktualizacja zbiorcza',
      daysOfWeek: {
        monday: 'Poniedziałek',
        tuesday: 'Wtorek',
        wednesday: 'Środa',
        thursday: 'Czwartek',
        friday: 'Piątek',
        saturday: 'Sobota',
        sunday: 'Niedziela'
      },
      form: {
        dayOfWeek: 'Dzień tygodnia',
        selectDayOfWeek: 'Wybierz dzień tygodnia',
        dateRange: 'Zakres dat',
        entireYear: 'Cały rok',
        customRange: 'Zakres niestandardowy',
        year: 'Rok',
        customDateRange: 'Niestandardowy zakres dat',
        startDate: 'Data początkowa',
        endDate: 'Data końcowa',
        tradeDaySettings: 'Ustawienia dnia handlowego'
      },
      dialog: {
        title: 'Aktualizacja zbiorcza dni handlowych',
        titleConfigure: 'Aktualizacja zbiorcza - Konfiguracja',
        titlePreview: 'Aktualizacja zbiorcza - Podgląd',
        titleConfirm: 'Aktualizacja zbiorcza - Potwierdzenie',
        cancel: 'Anuluj',
        previewDates: 'Podgląd dat',
        back: 'Wstecz',
        proceedToConfirm: 'Przejdź do potwierdzenia'
      },
      preview: {
        summary: 'Podsumowanie',
        totalAffected: 'Łączna liczba dat',
        newEntries: 'Nowe wpisy',
        overwrites: 'Nadpisania',
        affectedDates: 'Dotknięte daty',
        new: 'Nowy',
        willOverwrite: 'Zostanie nadpisany',
        showAllDates: 'Pokaż wszystkie {count} dat',
        showLess: 'Pokaż mniej',
        overwriteWarning: 'Ostrzeżenie o nadpisaniu',
        overwriteWarningMessage: '{count} istniejących dni handlowych zostanie nadpisanych nowymi wartościami.',
        infoTitle: 'Przejrzyj przed kontynuacją',
        infoMessage:
          'Proszę dokładnie przejrzeć dotknięte daty. W następnym kroku będziesz musiał potwierdzić tę operację.'
      },
      confirmation: {
        title: 'Potwierdź aktualizację zbiorczą',
        warningTitle: 'Ostrzeżenie: Tej operacji nie można cofnąć',
        warningMessage: 'Zamierzasz wykonać operację aktualizacji zbiorczej:',
        totalDates: 'Łączna liczba dat do zaktualizowania: {count}',
        overwriteCount: '{count} istniejących dni handlowych zostanie nadpisanych',
        cannotUndo: 'Tej operacji nie można cofnąć',
        summaryTitle: 'Podsumowanie operacji',
        typeToConfirm: 'Wpisz "{text}" aby potwierdzić:',
        confirmationMismatch: 'Proszę wpisać CONFIRM dokładnie jak pokazano powyżej',
        cancel: 'Anuluj',
        confirmButton: 'Potwierdź i wykonaj'
      },
      validation: {
        dayOfWeekRequired: 'Dzień tygodnia jest wymagany',
        yearRequired: 'Rok jest wymagany',
        fromDateRequired: 'Data początkowa jest wymagana',
        toDateRequired: 'Data końcowa jest wymagana',
        toDateBeforeFromDate: 'Data końcowa musi być późniejsza niż data początkowa',
        noMatchingDates: 'Brak dat spełniających wybrane kryteria'
      },
      messages: {
        successCount: '{count} dni handlowych zaktualizowano pomyślnie',
        failureCount: '{count} dni handlowych nie udało się zaktualizować'
      }
    }
  },
  marketingFileUpload: {
    dropZoneText: 'Przeciągnij pliki tutaj lub kliknij, aby wybrać',
    dropZoneHint: 'Dozwolone: {extensions}',
    filesReady: '{count} plik(ów) gotowych',
    totalSize: '{size} łącznie',
    clearAll: 'Wyczyść wszystko',
    upload: 'Prześlij {count} plik(ów)',
    cancel: 'Anuluj',
    currentFile: 'Aktualny plik',
    removeFile: 'Usuń {name}',
    confirmTitle: 'Potwierdź przesyłanie',
    confirmMessage: 'Przesłać {count} plików ({size}) do kampanii "{campaign}"?',
    uploadSuccess: 'Plik przesłany pomyślnie | {count} plików przesłano pomyślnie',
    uploadError: 'Błąd przesyłania pliku',
    partialSuccess: '{success} z {total} plików przesłano. {failed} nie powiodło się.',
    validationErrors: {
      invalidType: 'Typ pliku "{ext}" nie jest dozwolony',
      fileTooLarge: 'Rozmiar pliku {size} przekracza maksimum {max}',
      maxFilesExceeded: 'Maksymalnie {max} plików'
    }
  },
  hotkeys: {
    title: 'Skróty klawiszowe',
    previousPage: 'Poprzednia strona',
    nextPage: 'Następna strona',
    newArticle: 'Nowy artykuł',
    editHoveredArticle: 'Edytuj wskazany artykuł',
    editArticleArea: 'Narysuj ponownie obszar artykułu',
    closeDialog: 'Zamknij okno',
    saveArticle: 'Zapisz artykuł',
    cancelEditing: 'Anuluj edycję',
    showHelp: 'Pokaż skróty klawiszowe',
    dashboard: {
      moveDown: 'Przesuń fokus w dół',
      moveUp: 'Przesuń fokus w górę',
      enterLeaflets: 'Wejdź do listy gazetek',
      exitLeaflets: 'Wyjdź z listy gazetek',
      clearFocus: 'Wyczyść fokus',
      focusSearch: 'Fokus na wyszukiwarkę',
      primaryAction: 'Przełącz listę / Edytuj gazetkę',
      addLeaflet: 'Dodaj gazetkę',
      editStore: 'Edytuj sklep',
      delete: 'Usuń zaznaczony element',
      activateAllLeaflets: 'Aktywuj wszystkie gazetki',
      goToPageDetails: 'Przejdź do przekierowań i insertów',
      openPageDetailsImages: 'Otwórz zdjęcia stron',
      openArticlesData: 'Otwórz dane artykułów',
      syncLongUrl: 'Synchronizuj długi URL',
      copySeoId: 'Kopiuj SEO ID'
    },
    menuNavigation: 'Otwórz nawigację menu',
    menuNav: {
      hintRoot: 'Naciśnij literę aby nawigować',
      hintEsc: 'Esc aby anulować',
      hintBack: 'Esc aby wrócić',
      back: 'Wróć'
    }
  }
}
